module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_lg module",
    attrs: {
      "id": "module_1"
    }
  }, [_c('div', {
    staticClass: "scene"
  }, [_c('svg', {
    class: _vm.lab_state,
    attrs: {
      "id": "lab",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "100%",
      "viewBox": "0 0 1280 572"
    }
  }, [_c('g', {
    attrs: {
      "id": "Module-1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "id": "lab_bg",
      "fill": "#7BADD6",
      "fill-rule": "nonzero",
      "d": "M0 0h1280v572H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_ground",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M-.5 504h1280",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box4_4",
      "fill": "#6090B8",
      "d": "M78 463h100v65H78z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box4_3",
      "fill": "#4E7CA2",
      "d": "M118 468h20c2.76 0 5 2.24 5 5s-2.24 5-5 5h-20c-2.76 0-5-2.24-5-5s2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box4_2",
      "fill": "#6A9BC4",
      "d": "M88 484h80v38H88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box4_1",
      "fill": "#6A9BC4",
      "d": "M73 448h110v15H73z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "plans_6",
      "fill": "#5585AE",
      "d": "M152 398h80v130h-80z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "plans_5",
      "fill": "#6A9BC4",
      "d": "M153 398h20l-12.87-72.36c-3.4-.8-6.97-.8-10.7 0-3.73.8-7.04 2.14-9.92 4L153 398z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "plans_4",
      "fill": "#6A9BC4",
      "d": "M171 398l20 .28 3.38-66.9c-3.13-1.56-6.6-2.36-10.43-2.4-3.82-.06-7.34.5-10.56 1.66L171 398z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "plans_3",
      "fill": "#6A9BC4",
      "d": "M194 398h19l14.7-71.95c-2.84-2.16-6.15-3.54-9.93-4.1-3.77-.58-7.35-.43-10.74.46L194 398z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "plans_2",
      "fill": "#5585AE",
      "d": "M217 398h10l16.2-64.3c-.96-1.7-2.23-2.7-3.8-2.98-1.57-.28-3.14.05-4.72 1L217 398z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "plans_1",
      "fill": "#A2C5E2",
      "d": "M153 398h26c-9.03-42.7-13.65-64.8-13.87-66.36-8-.18-16.55-.84-25.62-2L153 398z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_background",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M912 232h222v125H912z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_line",
      "fill": "#FFF",
      "d": "M1119.27 345H926.73c-.34-.6-1-1-1.73-1-1.1 0-2 .9-2 2s.9 2 2 2c.74 0 1.4-.4 1.73-1h192.54c.34.6 1 1 1.73 1 1.1 0 2-.9 2-2s-.9-2-2-2c-.74 0-1.4.4-1.73 1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_Rectangle-8",
      "fill": "#FFF",
      "d": "M925 325.4h196v1H925z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_Rectangle-8",
      "fill": "#FFF",
      "d": "M925 304.8h196v1H925z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_Rectangle-8",
      "fill": "#FFF",
      "d": "M925 284.2h196v1H925z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_Rectangle-8",
      "fill": "#FFF",
      "d": "M925 263.6h196v1H925z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen3_Rectangle-8",
      "fill": "#FFF",
      "d": "M925 243h196v1H925z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "line_graph_first_group"
    }
  }, [_c('path', {
    attrs: {
      "id": "line_graph_first_path",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M929.12 324.54l46.14 -39.52 48.08 19.8 46.97 -62.55 47.24 84.27"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_frist_graph_5",
      "cx": "1117",
      "cy": "326",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_frist_graph_4",
      "cx": "1070",
      "cy": "243",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_frist_graph_3",
      "cx": "1023",
      "cy": "305",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_frist_graph_2",
      "cx": "976",
      "cy": "285",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "line_graph_first_anchor",
    attrs: {
      "id": "screen3_frist_graph_1",
      "cx": "929",
      "cy": "325",
      "r": "3",
      "fill": "#BED2EC",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_background",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M912 93h222v125H912z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "screen2_radar_bg_6",
      "cx": "1073",
      "cy": "154",
      "r": "50",
      "fill": "#FFF",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "radar_path",
    attrs: {
      "id": "radar_path_1",
      "fill-rule": "nonzero",
      "stroke": "#FFF",
      "stroke-opacity": ".2",
      "d": "M1073 194.5c-22.37 0-40.5-18.13-40.5-40.5s18.13-40.5 40.5-40.5 40.5 18.13 40.5 40.5-18.13 40.5-40.5 40.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "radar_path",
    attrs: {
      "id": "radar_path_2",
      "fill-rule": "nonzero",
      "stroke": "#FFF",
      "stroke-opacity": ".2",
      "d": "M1073 184.5c-16.84 0-30.5-13.66-30.5-30.5s13.66-30.5 30.5-30.5 30.5 13.66 30.5 30.5-13.66 30.5-30.5 30.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "radar_path",
    attrs: {
      "id": "radar_path_3",
      "fill-rule": "nonzero",
      "stroke": "#FFF",
      "stroke-opacity": ".2",
      "d": "M1073 174.5c-11.32 0-20.5-9.18-20.5-20.5s9.18-20.5 20.5-20.5 20.5 9.18 20.5 20.5-9.18 20.5-20.5 20.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-opacity": ".2",
      "fill-rule": "nonzero",
      "d": "M1073 164.5c-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5 10.5 4.7 10.5 10.5-4.7 10.5-10.5 10.5zm0-1c5.25 0 9.5-4.25 9.5-9.5s-4.25-9.5-9.5-9.5-9.5 4.25-9.5 9.5 4.25 9.5 9.5 9.5z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "1073",
      "cy": "154",
      "r": "2",
      "fill": "#FFF",
      "fill-opacity": ".2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "radar_point",
    attrs: {
      "id": "radar_point_1",
      "cx": "1073.5",
      "cy": "194.5",
      "r": "2.5",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "radar_point",
    attrs: {
      "id": "radar_point_2",
      "cx": "1073.5",
      "cy": "123.5",
      "r": "2.5",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "radar_point",
    attrs: {
      "id": "radar_point_3",
      "cx": "1052.5",
      "cy": "154.5",
      "r": "2.5",
      "fill": "#FFF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_line",
      "fill": "#FFF",
      "d": "M925 205.27v-99.54c.6-.34 1-1 1-1.73 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.4 1 1.73v99.54c-.6.34-1 1-1 1.73 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.4-1-1.73z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_10",
      "fill": "#FFF",
      "d": "M924 197h40v4h-40z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_9",
      "fill": "#FFF",
      "d": "M924 187h60v4h-60z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_8",
      "fill": "#FFF",
      "d": "M924 178h83v4h-83z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_7",
      "fill": "#FFF",
      "d": "M924 168h63v4h-63z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_6",
      "fill": "#FFF",
      "d": "M924 158h27v4h-27z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_5",
      "fill": "#FFF",
      "d": "M924 149h75v4h-75z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_4",
      "fill": "#FFF",
      "d": "M924 139h48v4h-48z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_3",
      "fill": "#FFF",
      "d": "M924 129h66v4h-66z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_2",
      "fill": "#FFF",
      "d": "M924 120h80v4h-80z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen2_bar_graph_1",
      "fill": "#FFF",
      "d": "M924 110h18v4h-18z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_screen_1",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M394 93h472v266H394z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_9",
      "fill": "#FFF",
      "d": "M845.26 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_8",
      "fill": "#FFF",
      "d": "M792.62 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_7",
      "fill": "#FFF",
      "d": "M737.16 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_6",
      "fill": "#FFF",
      "d": "M683.58 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_5",
      "fill": "#FFF",
      "d": "M630 94h.94v264H630z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_4",
      "fill": "#FFF",
      "d": "M575.48 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_3",
      "fill": "#FFF",
      "d": "M521.9 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_2",
      "fill": "#FFF",
      "d": "M467.38 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "screen_grid_1",
      "fill": "#FFF",
      "d": "M413.8 94h.94v264h-.94z",
      "opacity": ".1"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "newspaper"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M464.63 212h78.75c3.1 0 5.62 2.24 5.62 5v90c0 2.76-2.52 5-5.63 5H464c-2.76 0-5-2.24-5-5v-90c0-2.76 2.52-5 5.63-5zm4.95 78c-.32 0-.58.22-.58.5s.26.5.58.5h68.84c.32 0 .58-.22.58-.5s-.26-.5-.58-.5h-68.84zm0 11c-.32 0-.58.22-.58.5s.26.5.58.5h68.84c.32 0 .58-.22.58-.5s-.26-.5-.58-.5h-68.84zm0-21c-.32 0-.58.22-.58.5s.26.5.58.5h68.84c.32 0 .58-.22.58-.5s-.26-.5-.58-.5h-68.84zm47.6-33c-.1 0-.18.22-.18.5s.07.5.17.5h19.66c.1 0 .17-.22.17-.5s-.07-.5-.17-.5h-19.66zm0 11c-.1 0-.18.22-.18.5s.07.5.17.5h19.66c.1 0 .17-.22.17-.5s-.07-.5-.17-.5h-19.66zm0 11c-.1 0-.18.22-.18.5s.07.5.17.5h19.66c.1 0 .17-.22.17-.5s-.07-.5-.17-.5h-19.66zm.32-33c-.28 0-.5.22-.5.5s.22.5.5.5h19c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-19zm0-11c-.28 0-.5.22-.5.5s.22.5.5.5h19c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-19z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M470.57 273.37h1.77c.6 0 1.12-.14 1.55-.42.4-.3.74-.68.97-1.2.23-.5.35-1.1.35-1.8 0-.67-.12-1.26-.35-1.77-.23-.5-.56-.9-.98-1.2-.44-.27-.96-.4-1.56-.4h-1.77v6.8zm1.77.57h-3.3c-.02-.05-.04-.12-.04-.2 0-.1.03-.17.08-.24l.8-.1v-6.83h-.7c-.12 0-.18-.06-.18-.18 0-.06.02-.16.06-.3l.02-.1h3.26c.72 0 1.35.16 1.9.48.53.32.94.78 1.24 1.37.3.6.45 1.3.45 2.1 0 .83-.15 1.54-.45 2.14-.3.58-.7 1.04-1.25 1.36-.54.32-1.17.48-1.9.48zm11.2 0h-5.64c-.03-.05-.04-.12-.04-.2 0-.1.02-.17.08-.24l.8-.1v-6.83h-.7c-.12 0-.18-.06-.18-.18 0-.06.02-.16.06-.3l.02-.1h5.47c.12.1.22.2.3.32l.02 1.62c-.05.04-.1.05-.2.05-.08 0-.16-.03-.23-.1l-.32-1.33h-3.55v3.04h2.42l.1-.65c.03-.14.1-.22.2-.22.04 0 .1.02.2.06l.08.03V271c-.05.03-.12.05-.2.05-.08 0-.17-.03-.24-.1l-.15-.8h-2.42v3.22h3.67l.3-1.34c.08-.06.16-.1.25-.1.08 0 .14.03.2.06l-.03 1.62c-.08.12-.18.23-.3.32zm5.24.02l-2.7-7.4h-.7c-.13 0-.2-.05-.2-.17 0-.06.03-.16.07-.3l.02-.1h2.37c.04.05.05.1.05.2s-.04.17-.1.24l-.8.1 2.28 6.4 2.3-6.37h-.7c-.14 0-.2-.06-.2-.18 0-.06 0-.16.05-.3l.03-.1h2.3c.04.05.06.1.06.2s-.03.17-.1.24l-.8.1-2.7 7.42-.27.03c-.1 0-.2-.02-.27-.04zm10.33-.02h-3.05c-.03-.05-.05-.12-.05-.2 0-.1.03-.17.1-.24l1.16-.1v-2.3l-2.44-4.53h-.7c-.13 0-.2-.06-.2-.18 0-.06.02-.16.06-.3l.03-.1h2.4c.04.05.05.1.05.2s-.03.17-.08.24l-.8.1 2.08 3.98 2.07-3.95h-.7c-.13 0-.2-.06-.2-.18 0-.06.02-.16.06-.3l.03-.1h2.34c.03.05.05.1.05.2s-.04.17-.1.24l-.8.1-2.46 4.57v2.27H499c.13 0 .2.06.2.17 0 .06-.02.16-.06.3l-.03.1zm9.52.06l-4.58-6.9v6.27h.7c.13 0 .2.06.2.17 0 .06-.03.16-.07.3l-.02.1h-2.3c-.02-.05-.04-.12-.04-.2 0-.1.04-.17.1-.24l.8-.1v-6.83h-.7c-.12 0-.2-.06-.2-.18 0-.06.03-.16.07-.3l.03-.1h1.5l4.38 6.6v-6.03h-.7c-.13 0-.2-.06-.2-.18 0-.06.02-.16.06-.3l.03-.1h2.28c.03.05.05.1.05.2s-.03.17-.08.24l-.8.1v7.34l-.25.08-.25.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M489 261c-11.05 0-20-8.95-20-20s8.95-20 20-20 20 8.95 20 20-8.95 20-20 20zm.1-4.1c4.9-.05 8.46-1.58 10.67-4.62-2.78-3-6.34-4.54-10.68-4.6-4.35-.08-7.97 1.46-10.87 4.6 2.33 3.12 5.94 4.66 10.86 4.62zm.15-30.77c-8.64-.1-13.1 9.5-8.62 15.2-2.5 1.1-2.02 3.6-1.3 4.35-1.1-.2-2.34.74-1.37 2.24-.97.14-2.67-.5-3.18-1.9-1.67 2.82.15 4.4 2.24 3.84-.14.4-.66.57-1.16.57.55.44 3.18.03 3.14-1.4 1.25.3 2.84-.77 2.38-2.23.8.28 2.15-.5 2.47-1.7.3.2 2.42 1.7 5.38 1.7 2.97 0 5.07-1.4 5.43-1.7.38.83 1.56 1.8 3.22 1.7-.7 1.5.9 3.06 2.5 2.24-.14 2.17 2.2 1.8 2.52 1.4-.6 0-1.4-.2-1.37-.58.4.24 1.7.4 2.5-.26.8-.67 1.3-3.04.34-3.57-.6 1.36-1.54 1.7-2.86 1.9.37-1.05.03-2.6-1.67-2.25 1.1-2.5.26-4.36-1.96-4.36 4.6-6.58 0-15.08-8.62-15.2zm-.25 19.5c-4.8 0-8.72-4.22-8.72-9.4 0-2.52 1.95-1.27 2.96-1.7.26-.23.3-5 1.25-6.35-.2 2.92-.53 5.4.46 6.34h3.15c.1-.77.42-2.6.54-3.2.05.7.17 2.74.52 3.2h3.65c-.16-.6-.34-2.3-.25-3.2.26 1.18.6 2.4 1.2 3.2 2.3.55 3.97-.2 3.97 1.7 0 5.2-3.9 9.4-8.72 9.4z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "school_icon",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M457.04 236.3h35.72v73.02h-35.72V236.3zm35.72 31.83h22.56v41.2h-22.56v-41.2zm0-41.2h22.56v41.2h-22.56v-41.2zm-30.08 20.6v9.36h9.4v-9.4h-9.4zm15.04 0v9.36h9.4v-9.4h-9.4zm-15.04 20.6v9.36h9.4v-9.4h-9.4zm15.04 0v9.36h9.4v-9.4h-9.4zm-15.04 20.6v9.36h9.4v-9.4h-9.4zm15.04 0v9.36h9.4v-9.4h-9.4zm37.6-52.43h35.72v73.02h-35.72V236.3zm5.64 11.23v9.36h9.4v-9.4h-9.4zm15.04 0v9.36h9.4v-9.4H536zm-15.04 20.6v9.36h9.4v-9.4h-9.4zm15.04 0v9.36h9.4v-9.4H536zm-15.04 20.6v9.36h9.4v-9.4h-9.4zm15.04 0v9.36h9.4v-9.4H536zm-38.54 0v20.6h13.16v-20.6h-13.16zm6.58-37.45c3.63 0 6.58-2.94 6.58-6.56 0-3.62-2.95-6.55-6.58-6.55s-6.58 2.93-6.58 6.55c0 3.62 2.95 6.56 6.58 6.56zm.94-35.58h10.34v6.56h-10.34v4.68-11.24z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "lab_chip"
    }
  }, [_c('path', {
    attrs: {
      "id": "chip_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M518.15 215.7v14.98h-7.52V215.7h7.52zm20.2 0h5.18v93.62h-75.2v-78.64l18.8-14.98h51.23zm-35.24 0v14.98h-7.5V215.7h7.5zm2.9 73.02c10.4 0 18.8-8.38 18.8-18.72 0-10.34-8.4-18.72-18.8-18.72s-18.8 8.38-18.8 18.72c0 10.34 8.4 18.72 18.8 18.72zm-17.9-73.02v14.98h7.5V215.7h-7.5zm15.1 0h7.6v14.98h-7.5V215.7zm22.6 0v14.98h7.5V215.7h-7.5zm12.7 0h5.2v14.98h-10.4V215.7h5.2zm-20.2 0h7.6v14.98h-7.6V215.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "chip_1",
      "fill": "#FFF",
      "d": "M502.64 273.36h-3.74l-.86 2.82h-2.46l4.05-12.73h2.46l4 12.73h-2.6l-.9-2.82zm-3.02-2.1h2.7l-1.3-4.24h-.15l-1.25 4.24zm8.52 2.7h3.23v-8.3h-3.23v-2.2h8.97v2.2h-3.2v8.3h3.3v2.22h-8.9v-2.22z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_blueprint"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_blueprint_head"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M866 342.02V109.98H730c-54.68 0-99 44.32-99 99v34.04c0 54.68 44.32 99 99 99h136z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_blueprint_mouth",
      "fill": "#FFF",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M745 268h121v14H745c-3.87 0-7-3.13-7-7s3.13-7 7-7z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "aye_blueprint_eye_3",
      "width": "18.8",
      "height": "28.09",
      "x": "738.1",
      "y": "211.96",
      "fill": "#FFF",
      "fill-opacity": "0",
      "stroke": "#FFF",
      "stroke-width": "2",
      "rx": "9.4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_blueprint_eye_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M747 212.43v27.14",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_blueprint_eye_1",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M739.04 226h16.92",
      "stroke-linecap": "square"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "lab_info_group"
    }
  }, [_c('ellipse', {
    attrs: {
      "id": "info_point",
      "cx": "467.38",
      "cy": "200.72",
      "fill": "#FFF",
      "fill-opacity": ".8",
      "stroke": "#FFF",
      "stroke-width": "2",
      "rx": "2.82",
      "ry": "2.81"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "info_line",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M467.85 197.45v-30.9h169.32",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "TEXT-GOES-HERE",
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "16",
      "letter-spacing": ".96"
    }
  }, [_c('tspan', {
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "x": "467.38",
      "y": "166.11"
    }
  }, [_vm._v(_vm._s(_vm.lab_info_text))])])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1134.5 295h145",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1134.5 155h145",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M885.5 55.5v229c0 5.52 4.48 10 10 10h16",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_1",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M325.5 105.5V65.4c0-5.52 4.48-10 10-10h678c5.52 0 10 4.48 10 10v27.1",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_container_3",
      "fill": "#EDEDED",
      "d": "M203 484h156v44H203z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_container_2",
      "fill": "#FFF",
      "d": "M203 150h156v334H203z",
      "opacity": ".3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_containter_1",
      "fill": "#EDEDED",
      "d": "M203 105h71V0h14v105h71v45H203z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "lab_container_light",
    attrs: {
      "id": "lab_container_light_3",
      "cx": "266",
      "cy": "127",
      "r": "5",
      "fill": "#777777"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "lab_container_light",
    attrs: {
      "id": "lab_container_light_2",
      "cx": "246",
      "cy": "127",
      "r": "5",
      "fill": "#777777"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "lab_container_light",
    attrs: {
      "id": "lab_container_light_1",
      "cx": "226",
      "cy": "127",
      "r": "5",
      "fill": "#777777"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sensor_report"
    }
  }, [_c('path', {
    attrs: {
      "id": "report_heart_3",
      "stroke": "#FFF",
      "stroke-width": "6",
      "d": "M793 264c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_heart_2",
      "stroke": "#FFF",
      "stroke-width": "6",
      "d": "M793 264c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_heart_1",
      "fill": "#FFF",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M793 317c9.33-4.58 14-9.96 14-16.13 0-7.35-6.62-10.72-14-4.47-7.35-6.53-14-2.88-14 4.47 0 6.17 4.67 11.55 14 16.13z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_power_3",
      "stroke": "#FFF",
      "stroke-width": "6",
      "d": "M630 266c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_power_2",
      "stroke": "#FFF",
      "stroke-width": "6",
      "d": "M630 266c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "report_power_1",
      "fill": "#FFF",
      "points": "635.137114 284 632.093378 300.832539 643 300.832539 626.709246 322 629.906622 305.167461 619 305.167461",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_gear_3",
      "stroke": "#FFF",
      "stroke-width": "6",
      "d": "M468 266c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_gear_2",
      "stroke": "#FFF",
      "stroke-width": "6",
      "d": "M468 266c-21 0-38 17-38 38s17 38 38 38 38-17 38-38-17-38-38-38z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_gear_1",
      "fill": "#FFF",
      "d": "M466.4 317c-.48 0-.9-.35-.98-.82l-.4-2.3-3.14-1.32-1.54.93c-.38.22-.87.17-1.2-.13l-2.07-1.92c-.32-.3-.42-.76-.23-1.15l.94-2.04-1-2.56-2.02-.5c-.45-.1-.76-.5-.76-.96v-2.88c0-.5.36-.9.85-1l1.9-.28 1.25-3.03-1.03-1.6c-.26-.4-.2-.92.13-1.25l2.05-2.05c.32-.32.82-.4 1.22-.16l1.72 1 2.92-1.18.4-2c.08-.48.5-.82.97-.82h2.9c.47 0 .88.34.97.8l.4 2.02 3.12 1.32 2.05-1.14c.42-.23.94-.13 1.25.23l1.7 2.03c.28.3.33.74.14 1.1l-1.06 2.05 1.04 2.64 2.23.34c.5.07.85.5.85 1v2.82c0 .48-.33.9-.8.98l-2.28.47-1.3 3.1.97 1.95c.18.4.1.86-.2 1.16l-1.87 1.83c-.34.32-.85.37-1.24.1l-1.73-1.1-2.9 1.18-.4 2.3c-.1.47-.5.82-1 .82h-2.87zm1.6-8.4c3.1 0 5.6-2.5 5.6-5.6 0-3.1-2.5-5.6-5.6-5.6-3.1 0-5.6 2.5-5.6 5.6 0 3.1 2.5 5.6 5.6 5.6z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "report_line",
      "fill": "#FFF",
      "d": "M845.48 240h-49.6c-.32-.6-.93-1-1.62-1-.7 0-1.3.4-1.64 1H740.2c-.33-.6-.94-1-1.64-1s-1.3.4-1.64 1H686.4c-.34-.6-.95-1-1.65-1s-1.3.4-1.63 1h-50.54c-.33-.6-.94-1-1.64-1s-1.3.4-1.63 1h-51.47c-.33-.6-.94-1-1.64-1s-1.32.4-1.64 1h-50.54c-.33-.6-.94-1-1.64-1s-1.3.4-1.63 1h-51.48c-.33-.6-.94-1-1.64-1s-1.3.4-1.63 1h-50.54c-.33-.6-.94-1-1.64-1s-1.3.4-1.63 1H394v2h18.2c.32.6.93 1 1.62 1 .7 0 1.3-.4 1.64-1H466c.32.6.93 1 1.63 1 .7 0 1.3-.4 1.64-1h51.48c.33.6.94 1 1.63 1 .7 0 1.3-.4 1.64-1h50.54c.32.6.93 1 1.63 1 .7 0 1.3-.4 1.63-1h51.48c.34.6.95 1 1.64 1 .7 0 1.3-.4 1.64-1h50.54c.32.6.93 1 1.63 1 .7 0 1.3-.4 1.64-1h50.52c.33.6.94 1 1.64 1s1.3-.4 1.64-1h52.42c.33.6.94 1 1.64 1s1.3-.4 1.63-1h49.58c.33.6.94 1 1.64 1s1.3-.4 1.64-1H866v-2h-17.24c-.33-.6-.94-1-1.64-1s-1.3.4-1.64 1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_16",
      "fill": "#FFF",
      "d": "M825 213h12v28h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_15",
      "fill": "#FFF",
      "d": "M799 203h12v38h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_14",
      "fill": "#FFF",
      "d": "M772 183h12v59h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_13",
      "fill": "#FFF",
      "d": "M745 155h12v87h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_12",
      "fill": "#FFF",
      "d": "M718 146h12v95h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_11",
      "fill": "#FFF",
      "d": "M691 123h12v118h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_10",
      "fill": "#FFF",
      "d": "M665 110h12v131h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_9",
      "fill": "#FFF",
      "d": "M638 117h12v124h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_8",
      "fill": "#FFF",
      "d": "M611 123h12v118h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_7",
      "fill": "#FFF",
      "d": "M584 110h12v131h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_6",
      "fill": "#FFF",
      "d": "M557 134h12v108h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_5",
      "fill": "#FFF",
      "d": "M531 154h12v87h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_4",
      "fill": "#FFF",
      "d": "M504 146h12v95h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_3",
      "fill": "#FFF",
      "d": "M477 166h12v75h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_2",
      "fill": "#FFF",
      "d": "M450 182h12v59h-12z",
      "opacity": ".7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "report_bar",
    attrs: {
      "id": "report_bar_1",
      "fill": "#FFF",
      "d": "M423 190h12v51h-12z",
      "opacity": ".7"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_11",
      "fill": "#6090B8",
      "d": "M394 397h470v131H394z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_10",
      "fill": "#6A9BC4",
      "d": "M742 486h112v30H742z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_9",
      "fill": "#6A9BC4",
      "d": "M742 448h112v30H742z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_8",
      "fill": "#6A9BC4",
      "d": "M742 409h112v30H742z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_7",
      "fill": "#6A9BC4",
      "d": "M630 409h100v107H630z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_6",
      "fill": "#6090B8",
      "d": "M720 452c-4.42 0-8 2.95-8 6.6v8.8c0 3.65 3.58 6.6 8 6.6v-22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_5",
      "fill": "#6A9BC4",
      "d": "M518 409h100v107H518z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_4",
      "fill": "#6090B8",
      "d": "M528 452c4.42 0 8 2.95 8 6.6v8.8c0 3.65-3.58 6.6-8 6.6v-22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_3",
      "fill": "#6A9BC4",
      "d": "M406 409h100v107H406z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_2",
      "fill": "#6090B8",
      "d": "M496 452c-4.42 0-8 2.95-8 6.6v8.8c0 3.65 3.58 6.6 8 6.6v-22z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_table_1",
      "fill": "#6A9BC4",
      "d": "M384 386h490v11.17H384z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "lab_chair_8",
      "cx": "1221",
      "cy": "520",
      "r": "8",
      "fill": "#5585AE"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "lab_chair_7",
      "cx": "1155",
      "cy": "520",
      "r": "8",
      "fill": "#5585AE"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_chair_6",
      "fill": "#6090B8",
      "d": "M1144 500h89c5.52 0 10 4.48 10 10v5h-109v-5c0-5.52 4.48-10 10-10z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_chair_5",
      "fill": "#5585AE",
      "d": "M1181 462h15v38h-15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_chair_4",
      "fill": "#5585AE",
      "d": "M1215.5 368c4.7 0 8.5 3.87 8.5 8.65v62.7c0 4.78-3.8 8.65-8.5 8.65s-8.5-3.87-8.5-8.65v-62.7c0-4.78 3.8-8.65 8.5-8.65z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "lab_chair_3",
      "width": "109",
      "height": "22",
      "x": "1134",
      "y": "440",
      "fill": "#6A9BC4",
      "rx": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "lab_chair_2",
      "width": "65",
      "height": "90",
      "x": "1184",
      "y": "328",
      "fill": "#6090B8",
      "rx": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "lab_chair_1",
      "width": "65",
      "height": "90",
      "x": "1173",
      "y": "328",
      "fill": "#6A9BC4",
      "rx": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_4",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1134.5 295h145",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_3",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1134.5 155h145",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_2",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M885.5 55.5v229c0 5.52 4.48 10 10 10h16",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_wire_1",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M325.5 105.5V65.4c0-5.52 4.48-10 10-10h678c5.52 0 10 4.48 10 10v27.1",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_container_3",
      "fill": "#EDEDED",
      "d": "M203 484h156v44H203z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_container_2",
      "fill": "#FFF",
      "d": "M203 150h156v334H203z",
      "opacity": ".3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "lab_containter_1",
      "fill": "#EDEDED",
      "d": "M203 105h71V0h14v105h71v45H203z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "lab_light_3",
      "cx": "266",
      "cy": "127",
      "r": "5",
      "fill": "#A3E263"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "lab_light_2",
      "cx": "246",
      "cy": "127",
      "r": "5",
      "fill": "#F5CA23"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "lab_light_1",
      "cx": "226",
      "cy": "127",
      "r": "5",
      "fill": "#E3374C"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "binder2_3",
      "fill": "#A2C5E2",
      "d": "M440 316h30v70h-30z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "binder2_2",
      "fill": "#6A9BC4",
      "d": "M451.54 346.33h6.92c1.28 0 2.3 1.05 2.3 2.34v25.66c0 1.3-1.02 2.34-2.3 2.34h-6.92c-1.28 0-2.3-1.05-2.3-2.34v-25.66c0-1.3 1.02-2.34 2.3-2.34z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "binder2_1",
      "cx": "455",
      "cy": "331.17",
      "fill": "#4E7CA2",
      "rx": "5.77",
      "ry": "5.83"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "binder1_3",
      "fill": "#A2C5E2",
      "d": "M404 316h30v70h-30z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "binder1_2",
      "fill": "#6A9BC4",
      "d": "M415.54 346.33h6.92c1.28 0 2.3 1.05 2.3 2.34v25.66c0 1.3-1.02 2.34-2.3 2.34h-6.92c-1.28 0-2.3-1.05-2.3-2.34v-25.66c0-1.3 1.02-2.34 2.3-2.34z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "binder1_1",
      "cx": "419",
      "cy": "331.17",
      "fill": "#4E7CA2",
      "rx": "5.77",
      "ry": "5.83"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hand_6",
      "fill": "#4E7CA2",
      "d": "M579 361.34h20.16v24.62H579z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hand_5",
      "fill": "#6A9BC4",
      "d": "M582 358.45h9.84c1.66 0 3 1.34 3 3v7.88c0 2-1.6 3.6-3.6 3.6s-3.6-1.6-3.6-3.6v-3.64H579v-4.25c0-1.66 1.34-3 3-3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hand_4",
      "fill": "#6090B8",
      "d": "M599.16 361.34h12.22c2 0 3.62 1.63 3.62 3.63s-1.62 3.62-3.62 3.62h-12.22v-7.26z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hand_3",
      "fill": "#6090B8",
      "d": "M599.16 370.03h12.22c2 0 3.62 1.63 3.62 3.63s-1.62 3.62-3.62 3.62h-12.22v-7.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hand_2",
      "fill": "#6090B8",
      "d": "M599.16 378.72h12.22c2 0 3.62 1.63 3.62 3.62 0 2-1.62 3.63-3.62 3.63h-12.22v-7.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "hand_1",
      "fill": "#5585AE",
      "d": "M480.5 362.1l98.23-4.93c1.65-.1 3.06 1.2 3.15 2.84v23.2c0 1.65-1.34 3-3 3H481c-5.52 0-10-4.48-10-10v-4.12c0-5.33 4.18-9.72 9.5-10z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "head_3",
      "fill": "#A2C5E2",
      "d": "M501.14 331.12l26.48-2.4c15.07-1.37 28.4 9.73 29.77 24.8.06.82.1 1.65.1 2.48 0 16.57-13.43 30-30 30h-26.25c-14.5 0-26.25-11.75-26.25-26.25 0-14.87 11.34-27.28 26.14-28.63z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "head_2",
      "cx": "485.75",
      "cy": "360.5",
      "fill": "#6A9BC4",
      "rx": "8.25",
      "ry": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "head_1",
      "fill": "#5585AE",
      "d": "M519.36 333.8l8.44-.98c13.15-1.5 25.03 7.92 26.54 21.07.1.9.16 1.8.16 2.73 0 14.84-12.03 26.87-26.87 26.87h-8.12c-12.97 0-23.5-10.53-23.5-23.5 0-13.4 10.05-24.68 23.36-26.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "notes_4",
      "fill": "#6A9BC4",
      "d": "M0 92h160v200H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "notes_4",
      "fill": "#6A9BC4",
      "d": "M0 312h110v110H0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "notes_3",
      "fill": "#A2C5E2",
      "d": "M133 122h50v70h-50z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "notes_2",
      "fill": "#A2C5E2",
      "d": "M136 202h20v20h-20z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "notes_1",
      "fill": "#A2C5E2",
      "d": "M147 227h20v20h-20z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box2_4",
      "fill": "#6090B8",
      "d": "M879 463h100v65H879z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box2_3",
      "fill": "#4E7CA2",
      "d": "M919 468h20c2.76 0 5 2.24 5 5s-2.24 5-5 5h-20c-2.76 0-5-2.24-5-5s2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box2_2",
      "fill": "#6A9BC4",
      "d": "M889 484h80v38h-80z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box2_1",
      "fill": "#6A9BC4",
      "d": "M874 448h110v15H874z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box1_4",
      "fill": "#6090B8",
      "d": "M895 383h100v65H895z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box1_3",
      "fill": "#4E7CA2",
      "d": "M935 388h20c2.76 0 5 2.24 5 5s-2.24 5-5 5h-20c-2.76 0-5-2.24-5-5s2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box1_2",
      "fill": "#6A9BC4",
      "d": "M905 404h80v38h-80z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box1_1",
      "fill": "#6A9BC4",
      "d": "M890 368h110v15H890z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_8",
      "fill": "#6090B8",
      "d": "M980 463h100v65H980z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_7",
      "fill": "#4E7CA2",
      "d": "M1020 468h20c2.76 0 5 2.24 5 5s-2.24 5-5 5h-20c-2.76 0-5-2.24-5-5s2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_6",
      "fill": "#6A9BC4",
      "d": "M990 484h80v38h-80z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_5",
      "fill": "#4E7CA2",
      "d": "M1020 439h40c11.05 0 20 8.95 20 20v4h-80v-4c0-11.05 8.95-20 20-20z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_4",
      "fill": "#4E7CA2",
      "d": "M948.44 517.25l11.6-6 23.17-1.2.55 10.24c.1 1.88-1.37 3.48-3.3 3.58l-31.25 1.6c-1.92.1-3.55-1.34-3.65-3.22-.1-2.08 1.02-4.04 2.9-5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_3",
      "fill": "#6A9BC4",
      "d": "M984.14 448.62l1.12-1.15c3.92-4.04 9.87-3.25 14.48 0L1024 463h-31.97l-5.2-2.04c-3.9-1.53-5.84-5.94-4.3-9.84.37-.93.9-1.78 1.6-2.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_2",
      "fill": "#A2C5E2",
      "d": "M996.36 445.47l.46.15c5.9 1.88 9.13 8.1 7.2 13.9L985.3 516.2c-.6 1.8-2.56 2.78-4.4 2.2l-19.84-6.34c-1.83-.58-2.83-2.5-2.23-4.3.02-.08.05-.16.1-.24l23.12-55.5c2.3-5.53 8.54-8.37 14.3-6.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "box3_1",
      "fill": "#6A9BC4",
      "d": "M1076.94 417.22l24.74 107.18-14.62 3.38-24.74-107.18z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light3_3",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1120-1h15v31h-15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light3_2",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1095.62 30H1281v40h-211l6.2-24.85c2.24-8.9 10.24-15.15 19.42-15.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light3_1",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M1062.5 65H1281v5h-218.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light2_4",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M521-1h15v31h-15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light2_3",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M726-1h15v31h-15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light2_2",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M496.62 30h268.76c9.18 0 17.18 6.25 19.4 15.15L791 70H471l6.2-24.85c2.24-8.9 10.24-15.15 19.42-15.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light2_1",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M461 65h340v5H461z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light1_3",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M145-1h15v31h-15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light1_2",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M-1 30h185.38c9.18 0 17.18 6.25 19.4 15.15L210 70H-1V30z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "light1_1",
      "fill": "#7BADD6",
      "stroke": "#FFF",
      "stroke-width": "2",
      "d": "M-1 65h218.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5H-1v-5z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "aye_activation_container",
    class: {
      active: _vm.lab_interaction
    }
  }, [_c('p', {
    staticClass: "aye_activation_notification utility"
  }, [_vm._v("activating...")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('button', {
    staticClass: "aye_activation_button",
    on: {
      "click": _vm.lab_interaction_handle
    }
  }, [_vm._v("activate")])]), _vm._v(" "), _c('svg', {
    class: {
      speaking: _vm.ria_speaking
    },
    attrs: {
      "id": "ria",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "156",
      "height": "500",
      "viewBox": "0 0 156 500"
    }
  }, [_c('title', [_vm._v("\n        Ria\n      ")]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_foot_2",
      "fill": "#CC9D69",
      "d": "M50.18 449c-.1 19.56-16.03 28.26-21.9 31.88 7.24 1.47 38.12-1.46 39.98-3.62-.3-6.16-3.9-18.08-3.42-28.25.2-6-14.66-2.1-14.66 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_foot_1",
      "fill": "#BC2F2F",
      "d": "M32.1 477.75c-.4.6 4.2-4.9 5.67-6.35 2.15 0 10.16 1.46 13.78 2.93-3.62 4.4-5.38 5.97-1.47 5.1 11.24-2.17 15.64-2.65 18.08-3.63 2.74 3.22 3.7 13.1 2.25 15.93-3.6 2.16-10.3 1.76-12.1 1.57-.6-.7-.5-1.86-2.2-1.37-1.1.3-1.2 1.08-1.9 1.66-3 .9-38.2-.4-41.1-1.1-5-1.2-3.9-6.7 0-8 7.64-2.8 17.2-5.9 19.17-6.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_leg_bottom",
      "fill": "#2B5189",
      "d": "M76.47 465.04h-43.4V366.3c0-11.74 9.5-21.22 21.2-21.22h.7c11.82 0 21.5 9.58 21.5 21.5v98.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_leg_top",
      "fill": "#2B5189",
      "d": "M54.77 388.5c-12.02 0-21.7-9.7-21.7-21.72v-76.55c0-12.03 9.68-21.7 21.7-21.7s21.7 9.67 21.7 21.7v76.55c0 11.93-9.68 21.7-21.7 21.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_foot_2",
      "fill": "#D8A96F",
      "d": "M101.98 449c-.1 19.56-16.03 28.26-21.9 31.88 7.24 1.47 38.12-1.46 39.98-3.62-.3-6.16-3.9-18.08-3.43-28.25.2-6-14.65-2.1-14.65 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_foot_1",
      "fill": "#C92F2F",
      "d": "M83.9 477.75c-.4.6 4.2-4.9 5.66-6.35 2.15 0 10.17 1.46 13.78 2.93-3.6 4.4-5.37 5.97-1.46 5.1 11.24-2.17 15.63-2.65 18.08-3.63 2.73 3.22 3.7 13.1 2.25 15.93-3.6 2.16-10.3 1.76-12.1 1.57-.6-.7-.5-1.86-2.2-1.37-1.1.3-1.2 1.08-1.9 1.66-3 .9-38.2-.4-41.1-1.1-5-1.2-3.9-6.7 0-8 7.6-2.8 17.2-5.9 19.17-6.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_leg_bottom",
      "fill": "#2F539B",
      "d": "M128.26 465.04h-43.4V366.3c0-11.74 9.5-21.22 21.22-21.22h.68c11.83 0 21.5 9.58 21.5 21.5v98.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_leg_top",
      "fill": "#2F539B",
      "d": "M106.57 388.5c-12.02 0-21.7-9.7-21.7-21.72v-76.55c0-12.03 9.68-21.7 21.7-21.7s21.7 9.67 21.7 21.7v76.55c0 11.93-9.68 21.7-21.7 21.7z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_right_arm"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_right_arm_top",
      "fill": "#DDD",
      "d": "M33.95 223.3l-1.16-.18c-9.1-1.27-15.5-9.67-14.2-18.77l8.6-61.38c1.3-9.1 9.6-15.43 18.7-14.15l1.13.16c9.1 1.28 15.4 9.68 14.13 18.78l-8.63 61.38c-1.25 9.1-9.63 15.43-18.73 14.15z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ria_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "ria_right_hand",
      "fill": "#D8A96F",
      "d": "M17.44 267.3c-.53 3-1.5 9.66-8.57 17.88-3.36 3.9-4.44 11.8-8.48 17.9.55 1.68 6.02-.3 7.5-2.8 1.47-2.48 2.62-4.5 3.1-5.12.45-.6 1.32-.4 1.47.27.16.68-3.23 23.92-2.9 25.15.36 1.23 3.4 1.8 4.12.72.72-1.08 3.87-19.38 4.2-19.83.35-.44.98-.1 1.2.22.25.3-3.68 19.74-3.35 20.55.32.8 3.47 1.23 3.92.7.44-.55 4-20 4.4-20.4.43-.37 1.1-.2 1.32.24.2.44-3.87 19.05-3.53 19.94.35.9 3.38 1.44 3.8.67.43-.75 4.38-19.5 4.72-19.73.33-.22.72-.12.96.18.23.3-1.95 14.43-1.6 15.28.35.85 2.6 1.44 3.12.55.5-.88 4.37-24.82 4.24-30.4-.13-5.6-.4-15.87.08-18.58-1.1-.2-17.55-3.02-19.76-3.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_arm_bottom",
      "fill": "#DDD",
      "d": "M40.67 285.74l-31.45-4.42c-.78-.1-1.28-.77-1.17-1.55L18.8 203.2c1.3-9.1 9.68-15.44 18.78-14.16l1.16.17c9.1 1.3 15.42 9.7 14.14 18.8l-10.76 76.6c-.1.7-.77 1.3-1.45 1.2z"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_left",
      "fill": "#F4F4F4",
      "d": "M148.8 383.5s.96 8.8-67.45 8.8c-5.57 0-10.55-.1-15.24-.2-.3-10.55-.3-267.7-.1-280.2 4.7-1.38 9.7-2.16 14.9-2.16 27.2 0 49.8 21.12 51.5 48.3l16.4 225.46z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_right",
      "fill": "#EAEAEA",
      "d": "M66.78 392.1c-52.86-1.17-52.86-8.6-52.86-8.6l16.33-225.46c1.45-22 16.42-40.1 36.43-46.15-.3 9.5-.3 273.5.1 280.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_shirt",
      "fill": "#2F539B",
      "d": "M65.72 148.85l-6.84-33.24H83.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_neck",
      "fill": "#CC9D69",
      "d": "M59.85 95.07c2.94 9.78 2.15 16.82-2.93 21.5 6.06 6.08 24.43 5.88 33.23 1-2.93-4.9-6.84-10.76-1.95-22.5-.98-14.66-30.3-12.7-28.35 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_collar_2",
      "fill": "#FFF",
      "d": "M86.24 107.8l-20.52 41.05 28.34-10.76L96 110.7c-2.92-.98-6.83-1.96-9.76-2.93z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_collar_1",
      "fill": "#F4F4F4",
      "d": "M59.85 112.67L66 148.85l-16.9-8.8 2.94-22.5c2.54-1.55 6.06-3.6 7.8-4.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_coat_pocket",
      "fill": "#F4F4F4",
      "d": "M35.42 171.34l22.48 4.9v6.83l-22.48-4.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_hand_4",
      "fill": "#BC8E64",
      "d": "M135.5 291.8c1.17 4.78.48 10.06-.1 13-.7 2.93-3.62 5.47-5.47 6.55-1.86 1.07 1.75-16.82 1.75-16.82l3.82-2.74z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_hand_3",
      "fill": "#C69666",
      "d": "M133.25 296.68c0 1.96-1.47 10.85-2.54 13.2-.9 2.25-3.6 6.16-7.3 5.77-3.7-.4 5.2-19.07 5.2-19.07l4.7.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_hand_2",
      "fill": "#CC9D69",
      "d": "M118.7 318.97c1.84-.3 5.17-2.54 6.44-5.86 1.37-3.3 3.32-14.5 3.32-16.8s-4.98-3.3-6.25-1.3c-1.3 2-3.5 24.1-3.5 24.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_hand_1",
      "fill": "#D8A96F",
      "d": "M113.6 267.54c0 5.58-.3 10.86-5.27 16.53-5 5.57-4.6 18.18-6.65 23.46-1.95 5.28 5.96.98 6.94-2.64.98-3.7 2.64-9.9 5-9.6 2.33.3 1.94 8.9 1.94 13.5 0 2.6-.68 6.7-.68 9.3 0 1.9.3 3.6 1.66 3.6 4.3-3.6 6.64-16.5 6.25-22.1 1.6 0 10.8-1.7 13.1-4.3-.3-7.6-4.8-15.2-4.3-27.8.4-7.6-18.1-2.7-18.1 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_arm_bottom",
      "fill": "#FFF",
      "d": "M135.4 284.46h-31.76c-.8 0-1.37-.6-1.37-1.37v-77.4c0-9.2 7.43-16.7 16.6-16.7h1.2c9.17 0 16.6 7.4 16.6 16.6V283c0 .68-.6 1.37-1.27 1.37z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_arm_top",
      "fill": "#FFF",
      "d": "M120.06 223.55h-1.18c-9.18 0-16.6-7.43-16.6-16.62v-62c0-9.18 7.42-16.6 16.6-16.6h1.18c9.18 0 16.6 7.42 16.6 16.6v62c0 9.2-7.42 16.62-16.6 16.62z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_face",
      "fill": "#D8A96F",
      "d": "M104.7 64.57c0 22.4-16.2 41.75-34.1 41.75-22.57 0-30.88-22.78-30.88-41.75 0-29.92 12.4-40.38 32.45-40.38 17.98-.1 32.53 17.8 32.53 40.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_hair",
      "fill": "#CCC",
      "d": "M46.27 21.94c6.06-5.86 19.15-19.46 45.05-13.3 22.2 5.28 20.14 23.37 24.92 28.46 7.82 8.2 13.4 4.98 17.7 14.47 3.32 7.33-2.26 13-.2 20.53 1.37 4.98 14.27 23.76-11.93 27.28-27.5 3.7-19.7-20.34-20.1-28.26-.3-6.35-9.5-2.54-17.6-12.7C76.9 49.3 81.2 32 78.4 28c-4-5.57-18.96-3.13-25.5 1.27-13.1 8.6-18.58 40.87-5.88 63.85-9.2 13.2-40.86 4.7-23.75-20.63 5.3-7.9-5.36-12.1 1.3-24.9 5.75-11.2 21.8-25.7 21.8-25.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_open_bottom",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M63.97 92.16c-.97.98.1 6.07 4.1 6.07 4.02 0 8.4-5 8.12-5.48-.3-.5-4.4 2.44-8.12 2.44-4-.1-4.1-3.04-4.1-3.04z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_bottom",
      "fill": "#9E6954",
      "fill-rule": "nonzero",
      "d": "M63 92.92c1.56.4 10.36.5 13.3-.1 1.55-.3-1.97 2.65-7.83 2.65S63 92.92 63 92.92z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_mouth_top",
      "fill": "#634235",
      "fill-rule": "nonzero",
      "d": "M62.02 92.83c0-1.28.98-2.35 6.06-2.35 3.52 0 9.2 1.76 12.02.98.6-.2.6.3-.2.58-3.6 1.27-7.13 1.27-12.5 1.27-3.52-.08-5.38-.47-5.38-.47z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_nose",
      "fill": "#C99B69",
      "d": "M65.33 82.36H62.3c-1.27 0-2.25-.97-2.25-2.24l1.17-16.82c0-1.27.98-2.25 2.25-2.25h.78c1.27 0 2.25.98 2.25 2.25l1.17 16.82c-.1 1.17-1.17 2.24-2.34 2.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_glasses_4",
      "fill": "#C92F2F",
      "d": "M62 64.67c0-8.6-7.03-15.55-15.53-15.55-8.6 0-15.64 6.94-15.64 15.65 0 8.7 6.94 15.64 15.64 15.64 8.6 0 15.53-6.9 15.53-15.5V66h3.62v-1.9H62v.6z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "ria_glasses_3",
      "cx": "81.26",
      "cy": "64.77",
      "fill": "#C92F2F",
      "rx": "15.64",
      "ry": "15.64"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "ria_glasses_2",
      "cx": "46.47",
      "cy": "64.77",
      "fill": "#FFF",
      "rx": "13.88",
      "ry": "13.88"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "ria_glasses_1",
      "cx": "81.26",
      "cy": "64.77",
      "fill": "#FFF",
      "rx": "13.88",
      "ry": "13.88"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_right_brow",
      "fill": "#9E6954",
      "d": "M54.28 47.17c-1.95-.1-12.02-.4-15.93.1-1.85.2 2.35-2.94 9.4-2.94 7.02 0 6.53 2.84 6.53 2.84z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "ria_left_brow",
      "fill": "#9E6954",
      "d": "M73.15 47.26c1.95-.1 12.3-.48 16.32.1 1.85.3-2.45-3.03-9.58-3.03-7.3 0-6.8 2.93-6.8 2.93z"
    }
  })]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emotional_colors),
      expression: "emotional_colors"
    }],
    staticStyle: {
      "background": "#4A90E2"
    },
    attrs: {
      "id": "emotional_colors",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1280",
      "height": "1280",
      "viewBox": "0 0 1280 1280"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-opacity": "0",
      "fill-rule": "evenodd",
      "stroke": "#000",
      "stroke-width": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "637.4",
      "cy": "640",
      "r": "889.97",
      "transform": "rotate(115.2 637.403 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "637.93",
      "cy": "640",
      "r": "841",
      "transform": "rotate(108 637.928 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "638.43",
      "cy": "640",
      "r": "791.97",
      "transform": "rotate(100.8 638.432 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "638.96",
      "cy": "640",
      "r": "742.99",
      "transform": "rotate(93.6 638.958 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "638.96",
      "cy": "640",
      "r": "693.01",
      "transform": "rotate(86.4 638.965 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "639.46",
      "cy": "640",
      "r": "643.96",
      "transform": "rotate(79.2 639.458 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "595",
      "transform": "rotate(72 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "545",
      "transform": "rotate(64.8 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "495",
      "transform": "rotate(57.6 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "445",
      "transform": "rotate(50.4 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "395",
      "transform": "rotate(43.2 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "345",
      "transform": "rotate(36 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "295",
      "transform": "rotate(28.8 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "245",
      "transform": "rotate(21.6 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "195",
      "transform": "rotate(14.4 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "145",
      "transform": "rotate(7.2 640 640)"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "640",
      "cy": "640",
      "r": "95"
    }
  })])]), _vm._v(" "), _c('svg', {
    class: _vm.aye_state,
    style: (_vm.aye_styles),
    attrs: {
      "id": "aye",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "162",
      "height": "500",
      "viewBox": "0 0 162 500"
    }
  }, [_c('title', [_vm._v("\n        Aye\n      ")]), _vm._v(" "), _c('defs', [_c('path', {
    attrs: {
      "id": "path-1",
      "d": "M86 147c0 8.28-6.72 15-15 15-8.28 0-15-6.72-15-15 0-8.28 6.72-15 15-15 8.28 0 15 6.72 15 15z"
    }
  }), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter-2",
      "width": "136.7%",
      "height": "136.7%",
      "x": "-18.3%",
      "y": "-18.3%",
      "filterUnits": "objectBoundingBox"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "5",
      "in": "SourceAlpha",
      "result": "shadowBlurInner1"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dx": "1",
      "dy": "1",
      "in": "shadowBlurInner1",
      "result": "shadowOffsetInner1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "shadowOffsetInner1",
      "in2": "SourceAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1",
      "result": "shadowInnerInner1"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
      "in": "shadowInnerInner1"
    }
  })], 1)]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Characters",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_right_arm_3",
      "fill": "#D8D8D8",
      "d": "M32.5 292c6.92 0 12.5-5.6 12.5-12.53v-74.94C45 197.6 39.42 192 32.5 192S20 197.6 20 204.53v74.94C20 286.4 25.67 292 32.5 292z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_right_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_right_hand_2",
      "fill": "#BCC1BC",
      "d": "M20.04 279c-1.6 5.1-5 15-5.02 17-.03 2 4.2 2.34 5.55-1.73C21.92 290.2 22.6 288 23 287c.27.65 0 15 0 17 0 1.98 4.97 2.07 4.97 0 0-2.1 0-14.97.03-16 .03-1.03 1.06-1.04 1 0-.06 1.04.07 14.87.07 17 0 2.1 4.93 2.1 4.93 0v-17c0-.9 1-.95 1 0v16c0 2.02 5 2.05 5 0-.02-2.08 0-14.96 0-16 0-1.04 1-1.22 1 0v12c0 1.9 4.02 2.05 4 0-.02-2.05 0-15.05 0-21 0-5.95-22-9.43-24.96 0z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "aye_right_hand_1",
      "cx": "32.5",
      "cy": "279.5",
      "r": "12.5",
      "fill": "#B3B9B3"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_2",
      "fill": "#D8D8D8",
      "d": "M32.5 217c6.92 0 12.5-5.6 12.5-12.53v-74.94C45 122.6 39.42 117 32.5 117S20 122.6 20 129.53v74.94C20 211.4 25.67 217 32.5 217z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_arm_1",
      "fill": "#BCC1BC",
      "d": "M45 204.5c0 6.9-5.6 12.5-12.5 12.5S20 211.4 20 204.5 25.6 192 32.5 192 45 197.6 45 204.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_4",
      "fill": "#BCC1BC",
      "d": "M50.7 415.05c-3.3 10.67-21.6 22.45-26.18 23.12-3.23.5-3.83 7.37 1.06 7.54 7.3.28 40.16.36 49.03.28 1.23 0 2.28-1.1 2.36-2.46.45-6.85-2.03-25.32-3.24-27.86-1.42-3.05-22.03-3.73-23-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_3",
      "fill": "#D8D8D8",
      "d": "M62 432c-8.3 0-15-7.3-15-16.3v-97.4c0-9 6.7-16.3 15-16.3s15 7.3 15 16.3v97.4c0 9-6.7 16.3-15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_2",
      "fill": "#D8D8D8",
      "d": "M62 332c-8.3 0-15-7.3-15-16.3v-97.4c0-9 6.7-16.3 15-16.3s15 7.3 15 16.3v97.4c0 9-6.7 16.3-15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_leg_1",
      "fill": "#BCC1BC",
      "d": "M77 317c0 8.28-6.72 15-15 15-8.28 0-15-6.72-15-15 0-8.28 6.72-15 15-15 8.28 0 15 6.72 15 15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_body_main",
      "fill": "#E2E2E2",
      "d": "M32.52 121.17c16.98-17.2 75.3-17.53 88.9-1.12 14.62 17.53.74 107.95-44.45 107.95-45.2 0-58.93-92.17-44.45-106.83z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_orb_offset"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#777",
      "xlink:href": "#path-1"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "fill": "#000",
      "filter": "url(#filter-2)",
      "xlink:href": "#path-1"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb",
      "fill": "#4A90E2",
      "d": "M84 147c0 7.18-5.37 13-12 13s-12-5.82-12-13 5.37-13 12-13 12 5.82 12 13z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_orb_glare_2",
      "fill": "#FFF",
      "d": "M65.5 142c.74.5.95 1.5.45 2.25v.02c-.66.94-.97 1.85-.95 2.73.02.88.34 1.78.96 2.7.5.77.3 1.8-.46 2.3-.77.5-1.8.3-2.32-.46-.05-.07-.1-.14-.12-.2-.7-1.48-1.06-2.9-1.06-4.3s.35-2.87 1.07-4.37c.4-.83 1.4-1.18 2.22-.8.06.05.13.1.2.13z",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "aye_orb_glare_1",
      "cx": "66.5",
      "cy": "139.5",
      "r": "1.5",
      "fill": "#FFF",
      "opacity": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_4",
      "fill": "#BCC1BC",
      "d": "M89.7 415.05c-3.3 10.67-21.6 22.45-26.18 23.12-3.23.5-3.83 7.37 1.06 7.54 7.3.28 40.16.36 49.03.28 1.23 0 2.28-1.1 2.36-2.46.45-6.85-2.03-25.32-3.24-27.86-1.42-3.05-22.03-3.73-23-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_3",
      "fill": "#EFEFEF",
      "d": "M100 432c-8.3 0-15-7.3-15-16.3v-97.4c0-9 6.7-16.3 15-16.3s15 7.3 15 16.3v97.4c0 9-6.7 16.3-15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_2",
      "fill": "#EFEFEF",
      "d": "M100 332c-8.3 0-15-7.3-15-16.3v-97.4c0-9 6.7-16.3 15-16.3s15 7.3 15 16.3v97.4c0 9-6.7 16.3-15 16.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_leg_1",
      "fill": "#BCC1BC",
      "d": "M115 317c0 8.28-6.72 15-15 15-8.28 0-15-6.72-15-15 0-8.28 6.72-15 15-15 8.28 0 15 6.72 15 15z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "aye_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_arm_hand"
    }
  }, [_c('g', {
    attrs: {
      "id": "aye_left_hand"
    }
  }, [_c('path', {
    attrs: {
      "id": "aye_left_hand_2",
      "fill": "#BCC1BC",
      "d": "M107.03 278.84c-1.6 5.1-5 15-5.03 17-.02 2 4.2 2.34 5.55-1.73 1.35-4.05 2.04-6.25 2.43-7.25.27.64 0 15 0 17 0 1.98 4.98 2.06 4.98 0 0-2.1 0-14.98.02-16 .03-1.03 1.07-1.05 1 0-.06 1.04.07 14.87.07 17 0 2.1 4.93 2.1 4.93 0v-17c0-.9 1-.95 1 0v16c0 2.02 5 2.05 5 0-.02-2.08 0-14.96 0-16 0-1.04 1-1.22 1 0v12c0 1.9 4.03 2.05 4 0-.02-2.05 0-15.06 0-21 0-5.95-22-9.43-24.95 0z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "aye_left_hand_1",
      "cx": "119.5",
      "cy": "279.5",
      "r": "12.5",
      "fill": "#B2B2B2"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_3",
      "fill": "#EFEFEF",
      "d": "M119.5 292c-6.92 0-12.5-5.6-12.5-12.53v-74.94c0-6.93 5.58-12.53 12.5-12.53s12.5 5.6 12.5 12.53v74.94c0 6.93-5.58 12.53-12.5 12.53z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_2",
      "fill": "#EFEFEF",
      "d": "M119.5 217c-6.92 0-12.5-5.6-12.5-12.53v-74.94c0-6.93 5.58-12.53 12.5-12.53s12.5 5.6 12.5 12.53v74.94c0 6.93-5.58 12.53-12.5 12.53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_arm_1",
      "fill": "#BCC1BC",
      "d": "M132 204.5c0 6.9-5.6 12.5-12.5 12.5s-12.5-5.6-12.5-12.5 5.6-12.5 12.5-12.5 12.5 5.6 12.5 12.5z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_3",
      "fill": "#EFEFEF",
      "d": "M92.36 103H66.64C44.7 103 27 83.96 27 60.54 27 37.04 44.7 18 66.64 18h25.72C114.3 18 132 37.04 132 60.46c0 23.5-17.78 42.54-39.64 42.54z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_2",
      "fill": "#BCC1BC",
      "d": "M129 45c4.22 6.78 3.37 21.98 1 29-1.16.1-8.9.6-8.97-14.73-.08-14.75 7.04-14.16 7.97-14.27z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_head_1",
      "fill": "#777",
      "d": "M85.57 26H63.43C46.05 26 32 40.53 32 58.5v10C32 86.47 46.05 101 63.43 101h22.14C102.95 101 117 86.47 117 68.5v-10C117 40.53 102.87 26 85.57 26z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_frown",
      "fill": "#D7F4E5",
      "d": "M78.46 76.24c-5.76-2.76-12.58-3.93-18.48.42-1.52 1.18-2.73-1.67-1.22-2.85 6.52-4.8 14.17-3.7 20.53-.7 1.5.8.7 4-.9 3.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_unsure",
      "fill": "#D7F4E5",
      "d": "M82.67 75.67c-.5-3-2.56-5-4.75-4.46-1.15.3-1.92 1.3-2.77 2.3-.32.4-.7.9-1.15.7-.43-.2-.76-.9-1.02-1.4-.64-1.1-1.33-2-2.37-2.2-1.1-.2-2.2.3-3.2 1.1-1 .9-2 2.4-3.2 2.7-1.1.3-1.52-1.4-2.2-2.3-2.15-3-4.9-.5-6.62 1.9-.8 1.1.44 2.88 1.25 1.78.9-1.2 2.28-3.2 3.66-2.4.97.58 1.36 2.3 2.27 3.08 2.68 2.23 4.78-2.7 7.15-3.33 1.4-.37 1.86 1.1 2.68 2.33.77 1.16 1.83 1.7 2.93 1.06 1.06-.63 1.7-2.26 2.8-2.7 1.4-.56 2.67.7 3 2.6.27 1.56 1.96.9 1.7-.63"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_neutral",
      "fill": "#D7F4E5",
      "d": "M82 73.4c-8.34-.63-16.68-1.1-25.03-1.4-1.3-.05-1.3 2.56 0 2.6 8.35.32 16.7.78 25.04 1.4 1.3.1 1.3-2.5 0-2.6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_mouth_smile",
      "fill": "#D7F4E5",
      "d": "M78.32 72.65c-5.74 2.57-12.53 3.66-18.42-.4-1.5-1.08-2.72 1.56-1.2 2.65 6.48 4.52 14.1 3.5 20.45.7 1.58-.7.75-3.65-.83-2.95z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_left_eye",
      "fill": "#D7F4E5",
      "d": "M84.5 62c-1.43 0-2.5-1.03-2.5-2.2v-1.6c0-1.25 1.16-2.2 2.5-2.2 1.42 0 2.5 1.03 2.5 2.2v1.6c.08 1.17-1.08 2.2-2.5 2.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "aye_right_eye",
      "fill": "#D7F4E5",
      "d": "M53.5 62c-1.43 0-2.5-1.03-2.5-2.2v-1.6c0-1.25 1.16-2.2 2.5-2.2 1.43 0 2.5 1.03 2.5 2.2v1.6c0 1.17-1.16 2.2-2.5 2.2z"
    }
  })])]), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lab_ready_state.doors_active),
      expression: "lab_ready_state.doors_active"
    }],
    class: _vm.lab_ready_state,
    attrs: {
      "id": "lab_doors",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1280",
      "height": "572",
      "viewBox": "0 0 1280 572"
    }
  }, [_c('title', [_vm._v("\n        Lab Doors\n      ")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "right_door"
    }
  }, [_c('path', {
    attrs: {
      "id": "right_door_glass",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M640 .5h640v570H640z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_5",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M977.7 571.6h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_4",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M934.7 571.6h-70l200-259h70z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M763.7 570.6h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M1031.7 261.6h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M988.7 261.6h-70l200-259h70z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_frame_shadow",
      "fill": "#C1C1C1",
      "fill-rule": "nonzero",
      "d": "M695 571.5h-53V1.5h53v265l584.9-.4.2 50-585.1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_frame",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M690 571.5h-50V1.5h50v260h590v50H690z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_shadow",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_4",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M970.5 356H768.8c-7.8 0-14.1-6.3-14.1-14.1V230.1c0-7.8 6.3-14.1 14.1-14.1h201.7c7.8 0 14.1 6.3 14.1 14.1v111.7c.1 7.9-6.3 14.2-14.1 14.2z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "fingerprint_scanner"
    },
    on: {
      "click": _vm.open_lab
    }
  }, [_c('path', {
    attrs: {
      "id": "fingerprint_scanner_shadow",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_4",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M970.5 356H768.8c-7.8 0-14.1-6.3-14.1-14.1V230.1c0-7.8 6.3-14.1 14.1-14.1h201.7c7.8 0 14.1 6.3 14.1 14.1v111.7c.1 7.9-6.3 14.2-14.1 14.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "button_3",
      "fill": "#6D8C4A",
      "fill-rule": "nonzero",
      "d": "M962.3 342.5h-70.7c-6.2 0-11.2-5-11.2-11.2v-90.7c0-6.2 5-11.2 11.2-11.2h70.7c6.2 0 11.2 5 11.2 11.2v90.7c-.1 6.2-5.1 11.2-11.2 11.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "button_2",
      "fill": "#7ED320",
      "fill-rule": "nonzero",
      "d": "M958.9 339.1h-67.7c-6.2 0-11.2-5-11.2-11.2v-87.7c0-6.2 5-11.2 11.2-11.2h67.7c6.2 0 11.2 5 11.2 11.2v87.7c-.1 6.2-5.1 11.2-11.2 11.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "button_1",
      "fill": "#FFF",
      "d": "M904.9 266h-6.1c-.05-.1-.1-.23-.1-.4 0-.18.07-.35.2-.5l1.66-.2v-13.87h-1.45c-.25 0-.4-.12-.4-.35 0-.12.05-.32.14-.6l.05-.2h6.2c1.06 0 1.95.14 2.67.44.73.3 1.3.7 1.75 1.18.45.48.77 1 .98 1.6.2.56.3 1.12.3 1.68 0 .55-.1 1.1-.3 1.68-.2.58-.53 1.1-.98 1.6-.44.47-1.02.86-1.75 1.17-.72.3-1.6.44-2.66.44h-3.14v5.18h2.7c.27 0 .4.12.4.35 0 .12-.04.32-.12.6l-.05.2zm-2.94-7.48h3.15c1.3 0 2.34-.33 3.1-1 .76-.68 1.14-1.6 1.14-2.74 0-1.16-.38-2.07-1.14-2.74-.76-.68-1.8-1-3.1-1h-3.14v7.48zm23.73 7.13l-2.5.48c-.27-.16-.5-.34-.7-.56l.2-2.5c-.48 1.02-1.12 1.8-1.93 2.36-.8.55-1.72.82-2.76.82-1.24 0-2.2-.4-2.9-1.2-.67-.8-1-1.94-1-3.43v-6.94h-1.9c-.06-.12-.1-.24-.1-.36 0-.15.06-.3.16-.47l2.48-.47c.28.15.5.33.7.55v7.7c0 1.1.24 1.98.72 2.6.5.6 1.16.92 2.03.92.75 0 1.47-.23 2.13-.7.65-.45 1.18-1.05 1.58-1.8.4-.77.6-1.6.6-2.5v-5.47h-1.9c-.04-.12-.06-.24-.06-.36 0-.15.05-.3.15-.47l2.46-.47c.3.15.52.33.7.55v10.9h1.9c.05.1.08.23.08.35 0 .15-.05.3-.15.47zm2.56-.97l-.05-2.73c.13-.05.25-.07.4-.07.15 0 .3.05.46.14l.53 2.58c.8.37 1.75.55 2.8.55 1.05 0 1.86-.22 2.46-.65.6-.43.9-1.02.9-1.75 0-.6-.23-1.1-.68-1.52-.46-.42-1.18-.77-2.17-1.06-1.1-.3-2-.64-2.64-.98-.65-.35-1.1-.75-1.38-1.2-.28-.43-.42-.96-.42-1.57 0-1 .38-1.76 1.14-2.33.76-.57 1.8-.85 3.1-.85.6 0 1.23.06 1.88.18.64.1 1.12.26 1.43.44.2.22.35.47.5.75l.04 2.48c-.14.05-.26.07-.38.07-.16 0-.32-.05-.47-.15l-.54-2.3c-.7-.26-1.5-.4-2.37-.4-2 0-3 .7-3 2.1 0 .4.1.72.3 1 .2.27.53.52 1 .75.5.24 1.16.5 2 .75 1.4.42 2.43.93 3.07 1.54.65.6.97 1.37.97 2.3 0 1.07-.42 1.93-1.25 2.55-.85.64-2 .95-3.5.95-.7 0-1.37-.07-2.02-.23-.66-.15-1.2-.34-1.64-.6-.2-.2-.34-.46-.48-.75zm24.5 1.32h-4.82c-.05-.13-.08-.25-.08-.35 0-.13.05-.3.15-.47l1.7-.2v-7.1c0-2.36-.98-3.53-2.96-3.53-.8 0-1.5.23-2.16.7-.66.45-1.2 1.05-1.6 1.8-.4.77-.6 1.6-.6 2.5v5.57h1.46c.26 0 .4.12.4.35 0 .1-.04.28-.1.53l-.05.2h-4.84c-.05-.13-.07-.25-.07-.35 0-.13.04-.3.14-.47l1.7-.2v-14.56H939c-.04-.1-.06-.23-.06-.34 0-.16.05-.3.15-.48l2.6-.47c.27.15.5.33.7.55v6.4c.4-.8 1-1.45 1.74-2 .75-.56 1.7-.83 2.82-.83 1.34 0 2.35.4 3.05 1.2.7.78 1.06 1.92 1.06 3.43v7.05h1.45c.28 0 .4.1.4.34 0 .1-.02.28-.1.53l-.04.2zm-35.9 21.3v-7.7h-1.9c-.05-.13-.07-.25-.07-.35 0-.17.04-.33.14-.5l1.82-.23.4-2.62c.14-.03.3-.05.48-.05.1 0 .27.02.47.05v2.6h3.46c.27 0 .4.12.4.35 0 .1-.03.27-.1.52l-.05.23h-3.7v7.2c0 .78.06 1.4.15 1.9.1.46.28.8.57 1.03.3.2.75.32 1.37.32.3 0 .62-.03 1-.07.38-.06.75-.13 1.1-.23.16.27.25.58.3.95-.36.17-.8.3-1.3.4-.5.1-1 .15-1.5.15-.97 0-1.72-.28-2.25-.85s-.8-1.6-.8-3.1zm12.7 2.85c.87 0 1.63-.22 2.3-.67.65-.46 1.16-1.1 1.5-1.9.37-.82.55-1.76.55-2.83s-.17-2-.52-2.82c-.36-.82-.87-1.45-1.53-1.9-.66-.46-1.42-.68-2.3-.68-.85 0-1.62.22-2.27.67-.66.46-1.17 1.1-1.53 1.9-.36.82-.54 1.76-.54 2.83s.2 2 .55 2.82c.36.82.86 1.45 1.5 1.9.66.46 1.43.68 2.3.68zm0 1.1c-1.16 0-2.18-.27-3.03-.8-.86-.55-1.53-1.3-2.02-2.3-.47-.96-.7-2.1-.7-3.4 0-1.3.23-2.44.7-3.4.5-1 1.17-1.75 2.02-2.3.86-.53 1.88-.8 3.04-.8 1.17 0 2.18.27 3.04.8.86.55 1.53 1.3 2 2.3.5.96.74 2.1.74 3.4 0 1.3-.24 2.44-.73 3.4-.47 1-1.14 1.75-2 2.3-.86.53-1.87.8-3.04.8zm-24.92 23.82c1.2 0 2.24-.3 3.13-.88.9-.6 1.6-1.44 2.08-2.5.5-1.1.74-2.34.74-3.77 0-1.44-.26-2.7-.75-3.75-.5-1.07-1.18-1.9-2.08-2.5-.9-.58-1.93-.88-3.13-.88s-2.25.3-3.14.9c-.9.58-1.58 1.4-2.08 2.48-.5 1.06-.73 2.3-.73 3.75 0 1.45.23 2.7.72 3.77.5 1.07 1.2 1.9 2.08 2.5.9.58 1.94.88 3.14.88zm0 1.18c-1.5 0-2.8-.35-3.9-1.04-1.12-.68-2-1.65-2.6-2.9-.62-1.23-.93-2.7-.93-4.38 0-1.66.32-3.12.94-4.36.6-1.24 1.48-2.2 2.6-2.9 1.1-.7 2.4-1.04 3.9-1.04 1.48 0 2.78.35 3.9 1.04 1.1.7 1.98 1.66 2.6 2.9.6 1.24.92 2.7.92 4.37 0 1.68-.3 3.14-.92 4.38-.62 1.25-1.5 2.22-2.6 2.9-1.12.7-2.42 1.05-3.9 1.05zm15.6 4.38h-6.08c-.05-.12-.07-.24-.07-.36 0-.15.04-.3.14-.47l1.7-.2v-14.53c-.55.2-1.04.4-1.48.6-.23-.28-.37-.6-.42-.92.78-.45 1.7-.8 2.77-1.1 1.08-.26 2.1-.4 3.04-.4 1.25 0 2.34.27 3.28.8.95.55 1.68 1.3 2.2 2.26.53.97.8 2.1.8 3.38 0 1.3-.24 2.44-.72 3.43-.48 1-1.13 1.77-1.98 2.32-.84.56-1.8.83-2.9.83-1.24 0-2.32-.33-3.23-1v4.3h2.7c.25 0 .4.12.4.35 0 .1-.05.27-.1.53l-.06.2zm-2.95-15.93v9.25c1 .78 2.08 1.18 3.2 1.18.85 0 1.57-.23 2.2-.7.63-.45 1.1-1.08 1.46-1.9.35-.8.53-1.74.53-2.8 0-1.62-.46-2.92-1.36-3.9-.9-.97-2.1-1.45-3.6-1.45-.4 0-.8.02-1.2.08-.42.06-.84.14-1.25.24zm20.74 4.78h-8.4v.27c0 1.62.42 2.9 1.26 3.86.84.97 1.97 1.45 3.4 1.45.64 0 1.3-.1 2-.28.7-.18 1.25-.4 1.7-.62.12.13.22.28.3.44.05.15.1.3.1.47-1.37.8-2.82 1.18-4.34 1.18-1.16 0-2.18-.27-3.05-.8-.85-.55-1.53-1.3-2-2.3-.5-.96-.74-2.1-.74-3.4 0-1.32.23-2.46.7-3.44.45-.96 1.1-1.72 1.95-2.25.86-.53 1.86-.8 3-.8 3.08 0 4.6 1.82 4.6 5.48-.12.28-.28.53-.46.75zm-8.3-1.08h7.45c0-2.7-1.1-4.05-3.3-4.05-1.1 0-2 .37-2.75 1.1-.74.73-1.2 1.72-1.4 2.95zm24.5 7.6h-4.83c-.04-.13-.06-.25-.06-.35 0-.13.05-.3.15-.47l1.7-.2v-7.1c0-2.36-1-3.53-3-3.53-.77 0-1.5.23-2.15.7-.66.45-1.2 1.05-1.6 1.8-.4.77-.6 1.6-.6 2.5v5.57h1.46c.28 0 .4.12.4.35 0 .1-.02.28-.1.53l-.04.2h-4.82c-.05-.13-.08-.25-.08-.35 0-.13.05-.3.15-.47l1.7-.2v-10.3h-1.9c-.04-.12-.06-.24-.06-.36 0-.15.05-.3.15-.47l2.46-.48c.3.16.52.34.7.56l-.17 2.5c.45-1.02 1.1-1.8 1.9-2.36.83-.55 1.77-.82 2.84-.82 1.33 0 2.35.4 3.05 1.2.7.78 1.04 1.92 1.04 3.43v7.05H954c.25 0 .4.1.4.34 0 .1-.05.28-.1.53l-.06.2z"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_pound_2",
      "cx": "845.9",
      "cy": "329.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_pound_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M849.4 330.8h-1.7l-.4 2.1h-.5l.4-2.1h-1.7l-.4 2.1h-.6l.4-2.1h-1.2v-.3c0-.1 0-.2.1-.3h1.2l.5-2.4h-1.6v-.3c0-.1 0-.2.1-.3h1.7l.4-2.1h.5l-.4 2.1h1.7l.4-2.1h.5l-.4 2.1h1.2v.3c0 .1 0 .2-.1.3h-1.2l-.5 2.4h1.6v.6zm-2.2-.6l.5-2.4H846l-.5 2.4h1.7z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_asterisk_2",
      "cx": "788.6",
      "cy": "329.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_asterisk_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M788.9 331.6l-.6-1.3-1 1.1c-.1-.1-.2-.1-.2-.2l-.2-.2 1.1-1-1.3-.6c.1-.2.1-.4.3-.5l1.3.7.1-1.5h.3c.1 0 .2 0 .3.1l-.3 1.5 1.4-.3c0 .1.1.2.1.3v.3l-1.5.2.8 1.3c-.1.1-.2.1-.3.2-.1.1-.2-.1-.3-.1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_zero_2",
      "cx": "817.3",
      "cy": "329.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_zero_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M817.6 333.5c-.5 0-1-.1-1.4-.4-.4-.2-.7-.5-.9-.9-.2-.4-.4-.8-.5-1.3-.1-.5-.2-.9-.2-1.4 0-.5 0-.9.2-1.4.1-.5.3-.9.5-1.3s.5-.7.9-.9c.4-.2.8-.4 1.4-.4.5 0 1 .1 1.4.4.4.3.7.5.9.9.2.4.4.8.5 1.3.1.5.2.9.2 1.4 0 .5-.1.9-.2 1.4-.1.5-.3.9-.5 1.3s-.5.7-.9.9c-.4.3-.9.4-1.4.4zm0-.5c.4 0 .8-.1 1-.3.3-.2.5-.5.7-.8.2-.3.3-.7.4-1.1.1-.4.1-.8.1-1.2 0-.4 0-.8-.1-1.2-.1-.4-.2-.8-.4-1.1-.2-.3-.4-.6-.7-.8-.3-.2-.6-.3-1-.3s-.8.1-1 .3c-.2.2-.5.5-.7.8-.2.3-.3.7-.4 1.1-.1.4-.1.8-.1 1.2 0 .4 0 .8.1 1.2.1.4.2.8.4 1.1.2.3.4.6.7.8.2.2.6.3 1 .3z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_nine_2",
      "cx": "846.1",
      "cy": "300.5",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_nine_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M844.3 303.8c1-.4 1.8-1 2.4-1.6.6-.6 1-1.4 1.2-2.3-.2.4-.5.8-.8 1.1-.3.3-.8.4-1.3.4-.4 0-.9-.1-1.2-.3-.4-.2-.7-.5-.9-.9-.2-.4-.3-.8-.3-1.3s.1-.9.3-1.3c.2-.4.5-.7.9-.9.4-.2.8-.3 1.3-.3s1 .1 1.4.4c.4.2.7.6.9 1 .2.5.3 1 .3 1.6 0 .7-.2 1.4-.5 2-.3.6-.8 1.2-1.3 1.7-.6.5-1.3.9-2.1 1.2-.2-.1-.3-.3-.3-.5zm1.6-3c.4 0 .7-.1 1-.3.3-.2.5-.4.6-.7.2-.3.2-.6.2-1 0-.6-.2-1-.5-1.4-.3-.4-.8-.5-1.3-.5s-1 .2-1.3.5c-.3.4-.5.8-.5 1.4 0 .6.2 1 .5 1.4.3.4.7.6 1.3.6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_eight_2",
      "cx": "817.3",
      "cy": "300.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_eight_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M818.3 300.6c.6.2 1.1.5 1.3.8.3.4.4.8.4 1.3s-.1.9-.3 1.2c-.2.3-.5.6-.9.8-.4.2-.9.3-1.4.3-.5 0-1-.1-1.4-.3-.4-.2-.7-.4-.9-.8-.2-.3-.3-.7-.3-1.2s.1-.9.4-1.3c.3-.4.7-.7 1.3-.8-.4-.2-.8-.4-1-.7-.2-.3-.3-.7-.3-1 0-.4.1-.7.3-1 .2-.3.5-.5.8-.7.3-.2.7-.2 1.1-.2.4 0 .8.1 1.1.2.3.1.6.4.8.7.2.3.3.6.3 1s-.1.7-.3 1c-.2.3-.6.6-1 .7zm1 2.1c0-.3-.1-.6-.3-.9-.2-.3-.4-.5-.7-.6-.3-.2-.6-.2-1-.2s-.7.1-1 .2c-.3.2-.5.4-.7.6-.2.3-.3.6-.3.9 0 .3.1.6.3.9.2.2.4.4.7.6.3.1.6.2 1 .2s.7-.1 1-.2c.3-.1.5-.3.7-.6.2-.3.3-.5.3-.9zm-.4-3.8c0-.4-.1-.7-.4-1-.3-.3-.7-.4-1.1-.4-.4 0-.8.1-1.1.4-.3.3-.4.6-.4 1s.1.8.4 1c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.2-.2.4-.6.4-1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_seven_2",
      "cx": "788.6",
      "cy": "300.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_seven_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M786.8 303.9l3.5-6.9h-3.6l-.3 1.3c-.1.1-.2.1-.2.1h-.2v-1.6l.3-.3h4.5c.1.1.2.3.3.4l-3.6 7.4c-.3-.1-.5-.2-.7-.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_six_2",
      "cx": "845.9",
      "cy": "271.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_six_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M843.9 272.2c.2-.4.5-.8.8-1.1.4-.3.8-.4 1.3-.4.4 0 .9.1 1.2.3.4.2.7.5.9.9.2.4.3.8.3 1.3s-.1.9-.3 1.3c-.2.4-.5.7-.9.9-.4.2-.8.3-1.3.3s-1-.1-1.4-.4c-.4-.3-.7-.6-.9-1-.2-.4-.3-1-.3-1.6 0-.7.2-1.4.5-2 .3-.6.8-1.2 1.4-1.7.6-.5 1.3-.9 2.1-1.2.1.1.2.3.3.5-1 .4-1.8 1-2.4 1.6-.6.6-1.1 1.4-1.3 2.3zm2 3c.5 0 1-.2 1.3-.5.3-.4.5-.8.5-1.4 0-.6-.2-1-.5-1.4-.3-.4-.8-.5-1.3-.5-.4 0-.7.1-1 .3-.3.2-.5.4-.6.7-.2.3-.2.6-.2 1 0 .6.2 1 .5 1.4.3.2.8.4 1.3.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_five_2",
      "cx": "817.3",
      "cy": "271.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_five_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M814.9 270.9l.3-3.2c.1-.1.2-.3.3-.4l.9.3c.3.1.6.1.9.1.2 0 .5 0 .8-.1.3 0 .6-.1.8-.2.1.1.2.3.2.5-.1.1-.3.1-.5.2s-.4.1-.7.1c-.3 0-.5.1-.7.1h-.8c-.3 0-.5-.1-.7-.1l-.2 2.4c.2 0 .4-.1.6-.1h.7c.8 0 1.4.2 1.9.6.5.4.7 1 .7 1.8 0 .5-.1.9-.4 1.3-.2.4-.6.7-1 .9-.4.2-.9.3-1.5.3-.8 0-1.5-.2-2.2-.6 0-.2.1-.3.2-.5.6.3 1.3.5 1.8.5.7 0 1.3-.2 1.7-.5.4-.3.6-.8.6-1.4 0-.6-.2-1-.5-1.4-.3-.3-.8-.5-1.4-.5-.3 0-.5 0-.8.1-.3 0-.5.1-.6.2l-.4-.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_four_2",
      "cx": "788.6",
      "cy": "271.5",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_four_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M791.1 275.5h-2.7v-.2c0-.1 0-.2.1-.2l1.2-.1v-1.6H786c-.1-.1-.2-.2-.2-.4l4.2-5.3c.1 0 .1 0 .2.1.1 0 .1.1.2.1v5h1.1c.1 0 .2.1.2.2s0 .2-.1.3v.1h-1.2v1.5h.7c.1 0 .2.1.2.2-.1 0-.1.1-.2.3zm-1.4-2.6V269l-3 3.9h3z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_three_2",
      "cx": "846.1",
      "cy": "242.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_three_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M848.7 239.4l-2.4 2.9h.2c.7 0 1.3.2 1.7.6.4.4.6.9.6 1.6 0 .5-.1.9-.4 1.2-.2.4-.6.6-1 .9-.4.3-.9.3-1.5.3-.8 0-1.5-.2-2.2-.6 0-.2.1-.3.2-.5.6.3 1.3.5 1.8.5.7 0 1.3-.2 1.7-.5.4-.3.6-.8.6-1.3s-.2-.9-.5-1.2c-.3-.3-.8-.4-1.3-.4h-.4c-.1 0-.3 0-.4.1 0 0-.1-.1-.1-.2s-.1-.1-.1-.2l2.5-3h-3l-.3 1.1c-.1.1-.2.1-.2.1h-.2v-1.3l.3-.3h4.1c.2-.1.3 0 .3.2z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_two_2",
      "cx": "817.3",
      "cy": "242.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_two_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M819.8 246.2h-4.3l-.3-.3v-.2c0-.3.1-.7.2-1 .1-.3.4-.6.7-.9.3-.3.7-.7 1.3-1.1.5-.4.8-.7 1.1-.9.3-.3.5-.5.6-.7.1-.2.2-.5.2-.7 0-.4-.1-.8-.4-1-.3-.3-.6-.4-1.1-.4-.7 0-1.3.3-1.8 1-.2-.1-.3-.2-.4-.4.2-.4.6-.6 1-.8.4-.2.8-.3 1.3-.3.6 0 1.2.2 1.6.5.4.4.6.8.6 1.4 0 .3-.1.6-.2.9-.1.3-.3.6-.7.9-.3.3-.7.7-1.3 1.1-.5.4-.8.7-1.1 1-.3.3-.5.5-.6.8-.1.2-.2.5-.2.8h3.6l.3-1.4c.1-.1.2-.1.2-.1h.2v1.6c-.3 0-.4.1-.5.2z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_one_2",
      "cx": "788.6",
      "cy": "242.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_one_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M789.8 246.2h-3.5v-.2c0-.1 0-.2.1-.2l1.5-.1v-6.4l-1.6.9c-.1-.1-.2-.3-.3-.4l2.1-1.4c.1 0 .1 0 .2.1.1 0 .1.1.2.1v7.1h1.2c.1 0 .2.1.2.2 0 0-.1.1-.1.3z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "left_door"
    }
  }, [_c('path', {
    attrs: {
      "id": "left_door_glass",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M0 .5h640v570H0z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_frame_shadow",
      "fill": "#C1C1C1",
      "fill-rule": "nonzero",
      "d": "M587 1.5h53v570h-53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_frame",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M585 1.5h50v570h-50z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M192.6 571.5h-28.9L585 24.9v37.6z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_glare_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M131.2 571.5H17.4l439.4-570h113.7z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "warning_sign_3",
      "fill": "#F2C300",
      "fill-rule": "nonzero",
      "d": "M459.9 434.1c2.4-4.3 8.6-4.3 11.1 0l18.2 31.4 18.2 31.4c2.4 4.3-.6 9.6-5.5 9.6h-72.6c-4.9 0-8-5.3-5.5-9.6l18.2-31.4 17.9-31.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "warning_sign_2",
      "fill": "#3A3A3A",
      "fill-rule": "nonzero",
      "d": "M461.9 457.1h6.9v17l-1.3 8.4h-4.2l-1.3-8.4-.1-17zm-.8 32.7c0-1.2.4-2.2 1.1-2.9.7-.7 1.8-1.1 3-1.1 1.3 0 2.3.4 3.1 1.1.8.7 1.1 1.7 1.1 2.9s-.4 2.2-1.1 2.9c-.8.7-1.8 1.1-3.1 1.1s-2.2-.4-3-1.1c-.7-.7-1.1-1.7-1.1-2.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "warning_sign_1",
      "fill": "#3A3A3A",
      "fill-rule": "nonzero",
      "d": "M500 502.4h-69.2c-1.9 0-3.2-2.1-2.2-3.8l17.3-30 17.3-30c1-1.7 3.4-1.7 4.4 0l17.3 30 17.3 30c1 1.7-.2 3.8-2.2 3.8zm7.3-5.4l-18.2-31.4-18.2-31.4c-2.4-4.3-8.6-4.3-11.1 0l-18.2 31.4-18.1 31.4c-2.4 4.3.6 9.6 5.5 9.6h72.7c5 0 8-5.3 5.6-9.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_sign_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M512.7 415.9H52.1c-4.3 0-7.9-3.5-7.9-7.9V122.3c0-4.3 3.5-7.9 7.9-7.9h460.7c4.3 0 7.9 3.5 7.9 7.9V408c-.1 4.4-3.7 7.9-8 7.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_sign_1",
      "fill": "#A0D1F2",
      "fill-rule": "nonzero",
      "d": "M512.7 416H52.1c-4.3 0-7.9-3.5-7.9-7.9V232.5h476.4v175.6c0 4.4-3.6 7.9-7.9 7.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_logo_3",
      "fill": "#89C1EF",
      "fill-rule": "nonzero",
      "d": "M100.4 168.7c-3.5 0-6.4 2.9-6.4 6.4 0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4 0-3.6-2.8-6.5-6.4-6.4zm.1 10.7c-2.4 0-4.3-1.9-4.4-4.3-.1-2.4 1.9-4.3 4.3-4.4 2.4 0 4.3 1.9 4.4 4.3.1 2.4-1.9 4.4-4.3 4.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_logo_2",
      "fill": "#89C1EF",
      "fill-rule": "nonzero",
      "d": "M77.1 169.4c2.8-1.2 4.2-4.5 2.9-7.3-1.2-2.7-4.2-4-6.9-3.1v2c.1-.1.2-.1.3-.2 1.9-.8 4.1.1 4.9 2 .8 1.9-.1 4.1-2 4.9-1.1.5-2.3.4-3.3-.2v2c1.3.4 2.8.4 4.1-.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_logo_1",
      "fill": "#89C1EF",
      "fill-rule": "nonzero",
      "d": "M100.9 141.8l-19.6 11.6-.2 2.6 1.6 1.8 3.6-.4 1.4 3.3-2.8 2.2.2 2.4 2.5 2-1.2 3.3-3.4-.2-1.9 1.8.7 3.3-3.5 1.5-2.1-2.6h-2.7l-.5.7v16.2l27.8 16.5 27.8-16.5v-33l-27.7-16.5zm11.6 42.2l-2.8 3-3.5-1.7-2.8 1.1-.7 3.8h-4.3l-1.1-3.6-2.8-1.2-3.2 1.9-3-3.1 2.1-3-1.2-2.8-3.8-1.4v-4l3.6-.9 1.2-2.8-1.9-3.5 2.9-3 3.3 1.9 2.8-1.1 1-3.8h4.2l.9 3.6 2.8 1.2 3.5-1.9 2.8 2.9-1.7 3.3.9 2.6 4 1.2v4.2l-4 1.1-.8 2.6 1.6 3.4z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "text_2",
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "30",
      "letter-spacing": "1"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "73",
      "y": "316"
    }
  }, [_vm._v("TAKE A STAND:")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "73",
      "y": "351"
    }
  }, [_vm._v("Developing Emotional ")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "73",
      "y": "386"
    }
  }, [_vm._v("Intelligence/Empathy")])]), _vm._v(" "), _c('text', {
    attrs: {
      "id": "text_1",
      "fill": "#A0D1F2",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "40",
      "letter-spacing": "1"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "158",
      "y": "196"
    }
  }, [_vm._v("T.A.S. LABS")])])])])]), _vm._v(" "), _c('control-panel', {
    attrs: {
      "text": _vm.active_text,
      "control_panel_active": _vm.control_panel_active
    },
    on: {
      "textProgress": function($event) {
        _vm.text_update($event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.modal_active) ? _c('div', {
    staticClass: "info_modal"
  }, [(this.text.indexOf(this.active_text) == 14) ? _c('div', {
    staticClass: "info_modal_inner"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "span_6_xs modal_left"
  }, [_c('div', {
    staticClass: "modal_left_content"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Your teacher has activities to practice building these essential skills.")]), _vm._v(" "), _c('p', {
    staticClass: "modal_text"
  }, [_vm._v("Click the wheel to explore emotions.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.close_modal
    }
  }, [_vm._v("proceed")])])]), _vm._v(" "), _c('div', {
    staticClass: "span_6_xs modal_right"
  }, [_c('svg', {
    attrs: {
      "id": "emotional_pie",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "435",
      "height": "443",
      "viewBox": "0 0 435 443"
    },
    on: {
      "mouseleave": _vm.slice_leave
    }
  }, [_c('g', {
    attrs: {
      "id": "emotional_pie_inner",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('sad')
      },
      "click": function($event) {
        _vm.slice_select('sad')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200,200 C85.3372396,237.105469 21.9120049,257.698764 9.72429598,261.779885 C28.5107449,319.680827 72.9910136,366.004888 129.713612,387.300578 C135.615475,372.147068 159.044271,309.713542 200,200 Z",
      "id": "wedge_sad",
      "fill": "#5C6BC0"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group"
  }, [_c('g', {
    attrs: {
      "transform": "translate(78.000000, 291.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14,2 C20.64,2 26,7.36 26,14 C26,20.64 20.64,26 14,26 C7.36,26 2,20.64 2,14 C2,7.36 7.36,2 14,2 L14,2 Z M14,0 C6.28,0 0,6.28 0,14 C0,21.72 6.28,28 14,28 C21.72,28 28,21.72 28,14 C28,6.28 21.72,0 14,0 L14,0 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.12,22.2 C9.92,22.2 9.72,22.16 9.56,22.04 C9.08,21.72 8.96,21.12 9.28,20.64 C10.48,18.8 12.32,17.48 14.44,16.92 C16.56,16.36 18.8,16.56 20.76,17.56 C21.24,17.8 21.44,18.4 21.2,18.92 C20.96,19.4 20.36,19.6 19.84,19.36 C18.32,18.6 16.56,18.44 14.92,18.88 C13.28,19.32 11.84,20.36 10.92,21.76 C10.76,22.04 10.44,22.2 10.12,22.2 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group",
      "transform": "translate(7.200000, 9.600000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "11.6",
      "cy": "2",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "2",
      "cy": "2",
      "r": "2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('disgust')
      },
      "click": function($event) {
        _vm.slice_select('disgust')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200,400 C238.2993,400 274.084222,389.234667 304.49387,370.564897 C295.233634,355.140122 260.402344,298.285156 200,200 C160.877604,304.43099 137.448808,366.864515 129.713612,387.300578 C151.579974,395.509991 175.265638,400 200,400 Z",
      "id": "wedge_disgust",
      "fill": "#7E57C2"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group",
    attrs: {
      "id": "emoji_disgust"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(200.000000, 337.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14,2 C20.6276,2 26,7.3724 26,14 C26,20.6276 20.6276,26 14,26 C7.3724,26 2,20.6276 2,14 C2,7.3724 7.3724,2 14,2 L14,2 Z M14,0 C6.2804,0 0,6.2804 0,14 C0,21.7196 6.2804,28 14,28 C21.7196,28 28,21.7196 28,14 C28,6.2804 21.7196,0 14,0 L14,0 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.4248,23.4284 C16.1288,23.4284 15.4344,22.6704 14.9752,22.1696 C14.5528,21.7088 14.384,21.5596 14,21.5596 C13.616,21.5596 13.4472,21.7088 13.0248,22.1696 C12.5656,22.6708 11.8712,23.4284 10.5748,23.4284 C8.4796,23.4284 6.7748,21.7236 6.7748,19.6284 C6.7748,17.5332 8.4796,15.8284 10.5748,15.8284 C11.8712,15.8284 12.5656,16.5864 13.0248,17.0876 C13.4472,17.5484 13.6164,17.6976 14,17.6976 C14.3836,17.6976 14.5528,17.5484 14.9752,17.0876 C15.4344,16.586 16.1288,15.8284 17.4252,15.8284 C19.5204,15.8284 21.2252,17.5332 21.2252,19.6284 C21.2252,21.7236 19.52,23.4284 17.4248,23.4284 Z M14.6508,19.6284 C15.5416,19.8268 16.074,20.4084 16.45,20.8184 C16.8724,21.2792 17.0416,21.4284 17.4252,21.4284 C18.4176,21.4284 19.2252,20.6208 19.2252,19.6284 C19.2252,18.636 18.4176,17.8284 17.4252,17.8284 C17.0416,17.8284 16.8728,17.9776 16.45,18.4384 C16.0744,18.8484 15.5416,19.4304 14.6508,19.6284 Z M10.5752,17.8284 C9.5828,17.8284 8.7752,18.636 8.7752,19.6284 C8.7752,20.6208 9.5828,21.4284 10.5752,21.4284 C10.9592,21.4284 11.128,21.2792 11.5504,20.8184 C11.926,20.4084 12.4588,19.8268 13.3496,19.6284 C12.4588,19.4304 11.926,18.8488 11.5504,18.4384 C11.1276,17.9776 10.9588,17.8284 10.5752,17.8284 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.508,9.2928 C11.1176,8.902 10.484,8.902 10.094,9.2928 L9.2012,10.1856 L8.3084,9.2928 C7.9176,8.902 7.2844,8.902 6.8944,9.2928 C6.5036,9.6832 6.5036,10.3164 6.8944,10.7068 L7.7872,11.5996 L6.8944,12.4924 C6.5036,12.8828 6.5036,13.516 6.8944,13.9064 C7.0896,14.1016 7.3456,14.1992 7.6016,14.1992 C7.8576,14.1992 8.1136,14.1016 8.3088,13.9064 L9.2016,13.0136 L10.0944,13.9064 C10.2896,14.1016 10.5456,14.1992 10.8016,14.1992 C11.0576,14.1992 11.3136,14.1016 11.5088,13.9064 C11.8996,13.5156 11.8996,12.8824 11.5088,12.4924 L10.616,11.5996 L11.5088,10.7068 C11.8984,10.3164 11.8984,9.6832 11.508,9.2928 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2132,11.5996 L21.106,10.7068 C21.4968,10.3164 21.4968,9.6832 21.106,9.2928 C20.7152,8.902 20.0824,8.902 19.692,9.2928 L18.7992,10.1856 L17.9064,9.2928 C17.5156,8.902 16.8828,8.902 16.4924,9.2928 C16.1016,9.6832 16.1016,10.3164 16.4924,10.7068 L17.3852,11.5996 L16.4924,12.4924 C16.1016,12.8828 16.1016,13.516 16.4924,13.9064 C16.6876,14.1016 16.9436,14.1992 17.1996,14.1992 C17.4556,14.1992 17.7112,14.1016 17.9068,13.9064 L18.7996,13.0136 L19.6924,13.9064 C19.8876,14.1016 20.1436,14.1992 20.3996,14.1992 C20.6556,14.1992 20.9112,14.1016 21.1068,13.9064 C21.4976,13.5156 21.4976,12.8824 21.1068,12.4924 L20.2132,11.5996 Z",
      "id": "Shape"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('angry')
      },
      "click": function($event) {
        _vm.slice_select('angry')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200,200 C260.675781,299.815104 295.507071,356.67007 304.49387,370.564897 C354.670849,339.759126 390.213027,287.432615 398.268091,226.437678 C388.851082,225.010476 322.761719,216.197917 200,200 Z",
      "id": "wedge_angry",
      "fill": "#E57373"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group",
    attrs: {
      "id": "emoji_angry"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(314.000000, 266.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14,2 C20.6276,2 26,7.3724 26,14 C26,20.6276 20.6276,26 14,26 C7.3724,26 2,20.6276 2,14 C2,7.3724 7.3724,2 14,2 L14,2 Z M14,0 C6.2804,0 0,6.2804 0,14 C0,21.7196 6.2804,28 14,28 C21.7196,28 28,21.7196 28,14 C28,6.2804 21.7196,0 14,0 L14,0 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.2572,12.672 C11.1716,12.672 11.0844,12.6612 10.998,12.638 L6.5312,11.4412 C5.998,11.2984 5.6812,10.7496 5.824,10.2164 C5.9668,9.6828 6.5152,9.3656 7.0488,9.5092 L11.5156,10.706 C12.0488,10.8488 12.3656,11.3976 12.2228,11.9308 C12.1028,12.3772 11.6988,12.672 11.2572,12.672 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.7428,12.672 C16.3012,12.672 15.8972,12.3776 15.7772,11.9304 C15.6344,11.3972 15.9512,10.8484 16.4844,10.7056 L20.9516,9.5088 C21.4848,9.3676 22.0336,9.6824 22.1764,10.216 C22.3192,10.7492 22.0024,11.298 21.4692,11.4408 L17.002,12.6376 C16.9156,12.6608 16.8284,12.672 16.7428,12.672 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.166,20.7308 C19.9308,20.7308 19.6948,20.6484 19.5048,20.4804 C17.984,19.1384 16.0292,18.3992 14.0004,18.3992 C11.9716,18.3992 10.0168,19.1384 8.496,20.4804 C8.0816,20.846 7.45,20.806 7.0848,20.3924 C6.7192,19.9784 6.7588,19.3468 7.1728,18.9812 C9.0588,17.316 11.4836,16.3988 14.0004,16.3988 C16.5172,16.3988 18.942,17.3156 20.8284,18.9812 C21.2428,19.3464 21.2816,19.9784 20.9164,20.3924 C20.7184,20.6164 20.4428,20.7308 20.166,20.7308 Z",
      "id": "Shape"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('fearful')
      },
      "click": function($event) {
        _vm.slice_select('fearful')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200,200 C321.904948,216.072917 387.994311,224.885476 398.268091,226.437678 C399.410476,217.78725 400,208.962471 400,200 C400,146.276858 378.81792,97.5010552 344.349879,61.5687119 C335.871835,69.819779 287.755208,115.963542 200,200 Z",
      "id": "wedge_fearful",
      "fill": "#FF8A65"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group"
  }, [_c('g', {
    attrs: {
      "transform": "translate(330.000000, 142.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14,2 C20.6276,2 26,7.3724 26,14 C26,20.6276 20.6276,26 14,26 C7.3724,26 2,20.6276 2,14 C2,7.3724 7.3724,2 14,2 L14,2 Z M14,0 C6.2804,0 0,6.2804 0,14 C0,21.7196 6.2804,28 14,28 C21.7196,28 28,21.7196 28,14 C28,6.2804 21.7196,0 14,0 L14,0 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2792,21.8172 C19.0536,21.8172 18.4016,21.1072 17.9704,20.6368 C17.5804,20.212 17.4476,20.1044 17.1352,20.1044 C16.8224,20.1044 16.6984,20.2052 16.3036,20.6364 C15.8728,21.1068 15.2216,21.8172 13.9964,21.8172 C12.7716,21.8172 12.1208,21.1068 11.69,20.6364 C11.2952,20.2052 11.1708,20.1044 10.858,20.1044 C10.5456,20.1044 10.4216,20.2052 10.0268,20.6364 C9.596,21.1068 8.9452,21.8172 7.7204,21.8172 C7.168,21.8172 6.7204,21.3696 6.7204,20.8172 C6.7204,20.2648 7.168,19.8172 7.7204,19.8172 C8.0328,19.8172 8.1568,19.7164 8.5516,19.2852 C8.9824,18.8148 9.6332,18.1044 10.858,18.1044 C12.0828,18.1044 12.7336,18.8148 13.1648,19.2852 C13.5596,19.7164 13.6836,19.8172 13.9964,19.8172 C14.3092,19.8172 14.4336,19.7164 14.8288,19.2852 C15.2592,18.8148 15.9104,18.1044 17.1352,18.1044 C18.3604,18.1044 19.0124,18.8144 19.4436,19.2844 C19.8336,19.7092 19.9668,19.8172 20.2792,19.8172 C20.8316,19.8172 21.2792,20.2648 21.2792,20.8172 C21.2792,21.3696 20.8316,21.8172 20.2792,21.8172 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.2792,9.5996 C20.4944,9.5996 21.4792,10.5844 21.4792,11.7996 C21.4792,13.0148 20.4944,13.9996 19.2792,13.9996 C18.064,13.9996 17.0792,13.0148 17.0792,11.7996 C17.0792,10.5848 18.064,9.5996 19.2792,9.5996 L19.2792,9.5996 Z M19.2792,7.5996 C16.9632,7.5996 15.0792,9.4836 15.0792,11.7996 C15.0792,14.1156 16.9632,15.9996 19.2792,15.9996 C21.5952,15.9996 23.4792,14.1156 23.4792,11.7996 C23.4792,9.4836 21.5952,7.5996 19.2792,7.5996 L19.2792,7.5996 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.7208,9.5996 C9.936,9.5996 10.9208,10.5844 10.9208,11.7996 C10.9208,13.0148 9.936,13.9996 8.7208,13.9996 C7.5056,13.9996 6.5208,13.0148 6.5208,11.7996 C6.5208,10.5848 7.506,9.5996 8.7208,9.5996 L8.7208,9.5996 Z M8.7208,7.5996 C6.4048,7.5996 4.5208,9.4836 4.5208,11.7996 C4.5208,14.1156 6.4048,15.9996 8.7208,15.9996 C11.0368,15.9996 12.9208,14.1156 12.9208,11.7996 C12.9208,9.4836 11.0368,7.5996 8.7208,7.5996 L8.7208,7.5996 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "8.7208",
      "cy": "11.7996",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "19.2792",
      "cy": "11.7996",
      "r": "1"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('bad')
      },
      "click": function($event) {
        _vm.slice_select('bad')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200,200 C279.497396,124.123698 327.614022,77.9799352 344.349879,61.5687119 C307.950237,23.6227065 256.733808,0 200,0 C194.487049,0 189.026196,0.223056055 183.625973,0.660635557 C184.588866,15.5769827 190.046875,82.0234375 200,200 Z",
      "id": "wedge_bad",
      "fill": "#FEB64D"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group"
  }, [_c('g', {
    attrs: {
      "transform": "translate(239.000000, 45.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14,2 C20.6276,2 26,7.3724 26,14 C26,20.6276 20.6276,26 14,26 C7.3724,26 2,20.6276 2,14 C2,7.3724 7.3724,2 14,2 L14,2 Z M14,0 C6.2804,0 0,6.2804 0,14 C0,21.7196 6.2804,28 14,28 C21.7196,28 28,21.7196 28,14 C28,6.2804 21.7196,0 14,0 L14,0 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.4508,10.8652 L8.5624,9.2652 C8.0788,8.9976 7.4708,9.1724 7.2032,9.6556 C6.9356,10.1388 7.1104,10.7472 7.5936,11.0148 L8.9028,11.74 L7.5936,12.4652 C7.1104,12.7328 6.9356,13.3412 7.2032,13.8244 C7.386,14.154 7.7272,14.34 8.0788,14.34 C8.2428,14.34 8.4088,14.2996 8.5624,14.2148 L11.4508,12.6148 C11.4528,12.6136 11.4536,12.6116 11.4556,12.6104 C11.6124,12.5228 11.7476,12.3928 11.8412,12.2244 C12.1088,11.7416 11.934,11.1328 11.4508,10.8652 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.2996,12.4652 L18.9904,11.74 L20.2996,11.0148 C20.7828,10.7472 20.9576,10.1388 20.69,9.6556 C20.4224,9.1724 19.8136,8.9984 19.3312,9.2652 L16.4424,10.8652 C16.4376,10.868 16.4356,10.8728 16.4312,10.8756 C16.278,10.9632 16.144,11.0896 16.0524,11.2556 C15.7848,11.7388 15.9596,12.3472 16.4428,12.6148 L19.3316,14.2148 C19.4852,14.2996 19.6512,14.34 19.8152,14.34 C20.1668,14.34 20.508,14.154 20.6904,13.8244 C20.9576,13.3416 20.7828,12.7328 20.2996,12.4652 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.1816,20.7308 C19.9464,20.7308 19.7104,20.6484 19.5204,20.4804 C17.9996,19.1384 16.0452,18.3988 14.016,18.3988 C11.9868,18.3988 10.0324,19.1384 8.5116,20.4804 C8.0972,20.846 7.466,20.806 7.1004,20.3924 C6.7348,19.9784 6.7744,19.3468 7.1884,18.9812 C9.0744,17.316 11.4996,16.3988 14.016,16.3988 C16.5328,16.3988 18.9576,17.316 20.8436,18.9812 C21.2576,19.3468 21.2972,19.9784 20.9316,20.3924 C20.734,20.6164 20.4584,20.7308 20.1816,20.7308 Z",
      "id": "Shape"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('surprise')
      },
      "click": function($event) {
        _vm.slice_select('surprise')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200,200 C189.576823,75.0885417 184.118814,8.64208685 183.625973,0.660635557 C121.091847,5.72776913 66.6878857,39.5613038 33.663543,88.9117859 C47.2888893,98.0252828 102.734375,135.054687 200,200 Z",
      "id": "wedge_surprise",
      "fill": "#FDD835"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group"
  }, [_c('g', {
    attrs: {
      "transform": "translate(112.000000, 55.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14,2 C20.6276,2 26,7.3724 26,14 C26,20.6276 20.6276,26 14,26 C7.3724,26 2,20.6276 2,14 C2,7.3724 7.3724,2 14,2 L14,2 Z M14,0 C6.2804,0 0,6.2804 0,14 C0,21.7196 6.2804,28 14,28 C21.7196,28 28,21.7196 28,14 C28,6.2804 21.7196,0 14,0 L14,0 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "18.7992",
      "cy": "11.5996",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "9.2008",
      "cy": "11.5996",
      "r": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14,23.8004 C11.684,23.8004 9.8,21.7368 9.8,19.2004 C9.8,16.664 11.684,14.6004 14,14.6004 C16.316,14.6004 18.2,16.664 18.2,19.2004 C18.2,21.7368 16.316,23.8004 14,23.8004 Z M14,16.6004 C12.7868,16.6004 11.8,17.7668 11.8,19.2004 C11.8,20.634 12.7868,21.8004 14,21.8004 C15.2132,21.8004 16.2,20.634 16.2,19.2004 C16.2,17.7668 15.2132,16.6004 14,16.6004 Z",
      "id": "Shape"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_group",
    on: {
      "mouseover": function($event) {
        _vm.slice_over('happy')
      },
      "click": function($event) {
        _vm.slice_select('happy')
      }
    }
  }, [_c('path', {
    staticClass: "emotion_wedge",
    attrs: {
      "d": "M200.850586,200 C97.4658203,131.173177 41.736806,94.1437724 33.663543,88.9117859 C12.400079,120.687201 0,158.895504 0,200 C0,221.560232 3.41155714,242.323652 9.72429598,261.779885 C22.6965101,257.290561 86.4052734,236.697266 200.850586,200 Z",
      "id": "wedge_happy",
      "fill": "#80C683"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "emoji_group"
  }, [_c('g', {
    attrs: {
      "id": "Happy",
      "transform": "translate(36.000000, 169.000000)",
      "fill-rule": "nonzero",
      "fill": "#FFFFFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.8607887,1.97656338 C20.3950423,1.97656338 25.6917746,7.27329577 25.6917746,13.8075493 C25.6917746,20.3418028 20.3950423,25.6385352 13.8607887,25.6385352 C7.32653521,25.6385352 2.02980282,20.3418028 2.02980282,13.8075493 C2.02980282,7.27329577 7.32692958,1.97656338 13.8607887,1.97656338 L13.8607887,1.97656338 Z M13.8607887,0.00473239429 C6.24991549,0.00473239429 0.05797183,6.19667606 0.05797183,13.8075493 C0.05797183,21.4184225 6.24991549,27.6103662 13.8607887,27.6103662 C21.471662,27.6103662 27.6636056,21.4184225 27.6636056,13.8075493 C27.6636056,6.19667606 21.471662,0.00473239429 13.8607887,0.00473239429 L13.8607887,0.00473239429 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "18.5344225",
      "cy": "11.4362254",
      "r": "1.97183099"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "9.07121127",
      "cy": "11.4362254",
      "r": "1.97183099"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.6757183,17.6482817 C18.3944225,19.6082817 16.2029296,20.8209577 13.8028169,20.8209577 C11.4030986,20.8209577 9.21121127,19.6082817 7.92991549,17.6482817 L19.6757183,17.6482817 L19.6757183,17.6482817 Z M20.9865915,15.6764507 L6.61904225,15.6764507 C5.78140845,15.6764507 5.19380282,16.5290704 5.51994366,17.3008451 C6.88405634,20.528338 10.0784225,22.7931831 13.8028169,22.7931831 C17.5272113,22.7931831 20.7215775,20.528338 22.0856901,17.3008451 C22.411831,16.5294648 21.8242254,15.6764507 20.9865915,15.6764507 L20.9865915,15.6764507 Z",
      "id": "Shape"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_sad",
    class: {
      active: _vm.current_slice == 'sad'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_sad",
      "fill": "#383838",
      "d": "M120 305h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5h-46.7L179 361l-12.3-12.17H120c-2.76 0-5-2.24-5-5V310c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "155",
      "y": "334"
    }
  }, [_vm._v("Sad")])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_disgust",
    class: {
      active: _vm.current_slice == 'disgust'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_disgust",
      "fill": "#383838",
      "d": "M234 290h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5h-46.7L293 346l-12.3-12.17H234c-2.76 0-5-2.24-5-5V295c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "242",
      "y": "319"
    }
  }, [_vm._v("Disgust")])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_angry",
    class: {
      active: _vm.current_slice == 'angry'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_angry",
      "fill": "#383838",
      "d": "M312 180h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5h-46.7L371 236l-12.3-12.17H312c-2.76 0-5-2.24-5-5V185c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "329",
      "y": "209"
    }
  }, [_vm._v("Angry")])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_fearful",
    class: {
      active: _vm.current_slice == 'fearful'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_fearful",
      "fill": "#383838",
      "d": "M250 29h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5h-46.7L309 85l-12.3-12.17H250c-2.76 0-5-2.24-5-5V34c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "260",
      "y": "58"
    }
  }, [_vm._v("Fearful")])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_bad",
    class: {
      active: _vm.current_slice == 'bad'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_bad",
      "fill": "#383838",
      "d": "M142 1h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5h-46.7L201 57l-12.3-12.17H142c-2.76 0-5-2.24-5-5V6c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "176",
      "y": "30"
    }
  }, [_vm._v("Bad")])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_surprise",
    class: {
      active: _vm.current_slice == 'surprise'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_surprise",
      "fill": "#383838",
      "d": "M55 39h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5h-46.7L114 95l-12.3-12.17H55c-2.76 0-5-2.24-5-5V44c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "56",
      "y": "68"
    }
  }, [_vm._v("Surprise")])])]), _vm._v(" "), _c('g', {
    staticClass: "wedge_bubble wedge_happy",
    class: {
      active: _vm.current_slice == 'happy'
    }
  }, [_c('path', {
    attrs: {
      "id": "bubble_happy",
      "fill": "#383838",
      "d": "M5 178h118c2.76 0 5 2.24 5 5v33.83c0 2.76-2.24 5-5 5H76.3L64 234l-12.3-12.17H5c-2.76 0-5-2.24-5-5V183c0-2.76 2.24-5 5-5z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "24",
      "letter-spacing": "3"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "22",
      "y": "207"
    }
  }, [_vm._v("Happy")])])])])])]), _vm._v(" "), _c('emotion-expand', {
    attrs: {
      "active": _vm.emotion_expand_active,
      "selected-emotion": _vm.selected_slice
    },
    on: {
      "emotionexpandclosed": _vm.close_emotion_expand
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.text.indexOf(this.active_text) == 18) ? _c('div', {
    staticClass: "info_modal_inner blue"
  }, [_c('div', {
    staticClass: "row align_center"
  }, [_c('div', {
    staticClass: "span_8_xs offset_2_xs"
  }, [_c('p', {
    staticClass: "modal_text"
  }, [_vm._v("The same goes for you, students. Your teacher has more resources for you to learn more about the emotions of\n              others. Take a moment now to work through exercises with your instructor.")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.close_modal
    }
  }, [_vm._v("proceed")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('modal', {
    attrs: {
      "active": _vm.modalActive,
      "text": _vm.modalText,
      "ind": _vm.modalInd,
      "modalStyle": _vm.modalStyle
    },
    on: {
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aye_activation_progress"
  }, [_c('div', {
    staticClass: "aye_activation_color"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e48510c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/module_1/module_1.html
// module id = 641
// module chunks = 1